import React from "react";

export function IconHall({ bgColor = "none" }) {

  return <svg className="icon" width="16" height="16" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="13" height="1.5" rx="0.2"
      stroke="currentColor" fill="currentColor" strokeWidth="1" />

    <rect x="2" y="4.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
    <rect x="5" y="4.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
    <rect x="8" y="4.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
    <rect x="11" y="4.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />

    <rect x="3.5" y="7.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
    <rect x="6.5" y="7.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
    <rect x="9.5" y="7.5" width="1.5" height="1"
      stroke="currentColor" strokeWidth="1" />
  </svg>

}

export function IconRefresh({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2v2a8 8 0 1 1-4.5 1.385V8h2V2h-6v2H6a9.99 9.99 0 0 0-4 8"
      />
    </svg>
  );
}
export function IconPlus({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeWidth="2"
        d="M12 20v-8m0 0V4m0 8h8m-8 0H4"
      />
    </svg>
  );
}

export function IconMinus({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <rect width="10" height="1.5" x="3" y="7.25" fill={fillColor} rx=".5" />
    </svg>
  );
}



export const IconSearch = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
        <path
          fill={fillColor}
          d="M10.5 4a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13M2 10.5a8.5 8.5 0 1 1 15.176 5.262l3.652 3.652a1 1 0 0 1-1.414 1.414l-3.652-3.652A8.5 8.5 0 0 1 2 10.5M9.5 7a1 1 0 0 1 1-1a4.5 4.5 0 0 1 4.5 4.5a1 1 0 1 1-2 0A2.5 2.5 0 0 0 10.5 8a1 1 0 0 1-1-1"
        />
      </g>
    </svg>
  );
};
export const IconMenu = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1m0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1M3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1"
      />
    </svg>
  );
};
export const IconChevronDown = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06"
        clipRule="evenodd"
      />
    </svg>
  );
};
export const IconHome = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color={fillColor}
      >
        <path d="m9 22l.002-4.002c0-.931 0-1.396.153-1.763a2 2 0 0 1 1.083-1.083C10.605 15 11.07 15 12 15v0c.93 0 1.396 0 1.764.152a2 2 0 0 1 1.083 1.083C15 16.603 15 17.068 15 18v4" />
        <path d="m7.088 4.762l-1 .781c-1.516 1.184-2.275 1.776-2.681 2.61C3 8.988 3 9.952 3 11.88v2.092c0 3.784 0 5.676 1.172 6.852S7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.176S21 17.756 21 13.971v-2.09c0-1.929 0-2.893-.407-3.728c-.407-.834-1.165-1.426-2.681-2.61l-1-.78C14.552 2.92 13.372 2 12 2s-2.552.92-4.912 2.762" />
      </g>
    </svg>
  );
};
export const IconCategory = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2 18c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C3.689 14 4.46 14 6 14s2.31 0 2.876.347c.317.194.583.46.777.777C10 15.689 10 16.46 10 18s0 2.31-.347 2.877c-.194.316-.46.582-.777.776C8.311 22 7.54 22 6 22s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.776C2 20.31 2 19.54 2 18m12 0c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C15.689 14 16.46 14 18 14s2.31 0 2.877.347c.316.194.582.46.776.777C22 15.689 22 16.46 22 18s0 2.31-.347 2.877a2.36 2.36 0 0 1-.776.776C20.31 22 19.54 22 18 22s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.776C14 20.31 14 19.54 14 18M2 6c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C3.689 2 4.46 2 6 2s2.31 0 2.876.347c.317.194.583.46.777.777C10 3.689 10 4.46 10 6s0 2.31-.347 2.876c-.194.317-.46.583-.777.777C8.311 10 7.54 10 6 10s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.777C2 8.311 2 7.54 2 6m12 0c0-1.54 0-2.31.347-2.876c.194-.317.46-.583.777-.777C15.689 2 16.46 2 18 2s2.31 0 2.877.347c.316.194.582.46.776.777C22 3.689 22 4.46 22 6s0 2.31-.347 2.876c-.194.317-.46.583-.776.777C20.31 10 19.54 10 18 10s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.777C14 8.311 14 7.54 14 6"
        color={fillColor}
      />
    </svg>
  );
};
export const IconBasket = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.5 8h8.696c.625 0 .937 0 1.166.1c1.012.447.56 1.57.39 2.378a.48.48 0 0 1-.27.335a1.93 1.93 0 0 0-1.09 1.4l-.593 3.375c-.26 1.485-.35 3.606-1.65 4.652c-.955.76-2.33.76-5.081.76h-2.136c-2.75 0-4.126 0-5.08-.76c-1.301-1.046-1.39-3.167-1.651-4.652l-.593-3.375a1.93 1.93 0 0 0-1.09-1.4a.48.48 0 0 1-.27-.335c-.17-.807-.622-1.931.39-2.377C2.867 8 3.18 8 3.804 8H7.5m6.5 4h-4m-3.5-1L10 3m5 0l2.5 5"
        color={fillColor}
      />
    </svg>
  );
};
export const IconCall = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.778 11.942C2.83 10.29 2.372 8.94 2.096 7.572c-.408-2.024.526-4.001 2.073-5.263c.654-.533 1.404-.35 1.791.343l.873 1.567c.692 1.242 1.038 1.862.97 2.52c-.069.659-.536 1.195-1.469 2.267zm0 0c1.919 3.346 4.93 6.36 8.28 8.28m0 0c1.653.948 3.002 1.406 4.37 1.682c2.024.408 4.001-.526 5.262-2.073c.534-.654.351-1.404-.342-1.791l-1.567-.873c-1.242-.692-1.862-1.038-2.52-.97c-.659.069-1.195.536-2.267 1.469zM21 5.5h-8m8 0c0 .7-1.994 2.008-2.5 2.5M21 5.5c0-.7-1.994-2.008-2.5-2.5"
        color={fillColor}
      />
    </svg>
  );
};
export const IconUser = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.5 22H6.59c-1.545 0-2.774-.752-3.877-1.803c-2.26-2.153 1.45-3.873 2.865-4.715a10.67 10.67 0 0 1 7.922-1.187m3-7.795a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m.26 9.878c-1.08 0-1.543.78-1.663 1.26c-.12.479-.12 2.218-.048 2.938c.24.899.84 1.27 1.428 1.39c.54.049 2.82.03 3.48.03c.96.019 1.68-.341 1.98-1.42c.06-.36.12-2.34-.03-2.939c-.318-.96-1.041-1.259-1.641-1.259m-3.506 0h3.506m-3.506 0s-.002-.826 0-1.26c0-.398-.034-.78.156-1.13c.71-1.413 2.75-1.27 3.254.17c.087.237.093.612.09.96c-.003.442.006 1.26.006 1.26"
        color={fillColor}
      />
    </svg>
  );
};
export const IconUserCheck = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color={fillColor}
      >
        <path d="M14 18s1 0 2 2c0 0 3.177-5 6-6" />
        <path d="M13 22H6.59c-1.545 0-2.774-.752-3.877-1.803c-2.26-2.153 1.45-3.873 2.865-4.715c3.178-1.893 7.175-1.972 10.422-.239m.5-8.743a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0" />
      </g>
    </svg>
  );
};
export const IconClipBoard = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17 2v2m-5-2v2M7 2v2m-3.5 6c0-3.3 0-4.95 1.025-5.975S7.2 3 10.5 3h3c3.3 0 4.95 0 5.975 1.025S20.5 6.7 20.5 10v5c0 3.3 0 4.95-1.025 5.975S16.8 22 13.5 22h-3c-3.3 0-4.95 0-5.975-1.025S3.5 18.3 3.5 15zM8 15h4m-4-5h8"
        color={fillColor}
      />
    </svg>
  );
};
export const IconWallet = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color={fillColor}
      >
        <path d="M16 14a1.5 1.5 0 1 0 3 0a1.5 1.5 0 0 0-3 0m2.9-6q.1-.486.1-1a5 5 0 1 0-9.9 1" />
        <path d="M7 7.993h9c2.828 0 4.243 0 5.121.88c.879.878.879 2.293.879 5.123v2.001c0 2.83 0 4.245-.879 5.124C20.243 22 18.828 22 16 22h-6c-3.771 0-5.657 0-6.828-1.172S2 17.769 2 13.996v-2c0-3.774 0-5.66 1.172-6.833C4.115 4.22 5.52 4.036 8 4h2" />
      </g>
    </svg>
  );
};

export const Iconboat = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        fill={fillColor}
        d="M29.1 27.1c-1.1-.1-2.2.3-3.1 1.1c-1.1 1.1-2.9 1.1-4.1 0c-1-.7-2.1-1.1-3.3-1.1c-1.2-.1-2.4.3-3.3 1.1c-.6.5-1.3.8-2.1.8s-1.5-.3-2.1-.8c-1-.8-2.2-1.2-3.4-1.2s-2.4.4-3.4 1.2c-.6.5-1.5.8-2.3.8v2c1.3.1 2.6-.3 3.6-1.2c.6-.5 1.5-.8 2.3-.8c.7 0 1.5.3 2.1.8c1.8 1.6 4.6 1.6 6.5 0c.6-.5 1.3-.8 2.1-.8c.7 0 1.4.3 2 .8c1.9 1.6 4.6 1.6 6.5 0c.5-.5 1.3-.8 2-.8s1.4.3 1.9.8q1.35 1.05 3 1.2v-2c-1 0-1.2-.4-1.7-.8c-.9-.7-2-1.1-3.2-1.1"
        className="clr-i-outline clr-i-outline-path-1"
      />
      <path
        fill={fillColor}
        d="M6 23c0-.6.5-1 1.1-1H32l-3.5 3.1h.2c.8 0 1.6.2 2.2.5l2.5-2.2l.2-.2c.7-.8.6-2.1-.2-2.8c-.4-.2-.8-.4-1.3-.4h-25c-1.7 0-3 1.3-3 3v3.2c.5-.5 1.2-.8 1.9-1.1z"
        className="clr-i-outline clr-i-outline-path-2"
      />
      <path
        fill={fillColor}
        d="M8.9 19H15v-7.8c0-.6-.3-1.2-.8-1.6c-.9-.7-2.2-.5-2.8.4l-4.1 5.9c-.4.6-.4 1.4-.1 2.1c.3.6 1 1 1.7 1m4.2-7.8L13 17H8.9z"
        className="clr-i-outline clr-i-outline-path-3"
      />
      <path
        fill={fillColor}
        d="M26 18c.4-.6.4-1.4 0-2L19.7 5.6c-.4-.6-1-1-1.7-1c-1.1 0-2 .9-2 2V19h8.3c.7 0 1.4-.4 1.7-1M17.9 6.6l6.4 10.5h-6.4z"
        className="clr-i-outline clr-i-outline-path-4"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
};
export const IconWeather = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fill={fillColor}
        d="M14.517 10.016a4.481 4.481 0 0 0-8.908-.707q.51-.041 1.017-.004a3.483 3.483 0 1 1 6.704 1.84c.39-.056.764-.152 1.105-.27q.082-.418.082-.86m-9.44-5.634l-.07-.058a.5.5 0 0 0-.638.765l.858.858l.07.058a.5.5 0 0 0 .638-.765zm10.662.637a.5.5 0 0 0-.765-.637l-.859.858l-.058.07a.5.5 0 0 0 .765.637l.859-.858zM10.52 2.435a.5.5 0 0 0-.992.09v1.213l.008.09a.5.5 0 0 0 .992-.09V2.524zm-6.78 9.504c1.056-.576 2.036-.734 2.997-.614c.974.123 1.96.535 3.01 1.148c1.203.701 2.584.829 3.834.656c1.248-.173 2.41-.651 3.21-1.222a.5.5 0 0 0-.582-.814c-.658.47-1.666.893-2.765 1.045c-1.097.152-2.236.03-3.193-.529c-1.108-.646-2.227-1.13-3.39-1.276c-1.175-.147-2.365.054-3.6.728a.5.5 0 0 0 .479.878m0 2c1.056-.576 2.036-.734 2.997-.614c.974.123 1.96.535 3.01 1.148c1.203.701 2.584.829 3.834.656c1.248-.173 2.41-.651 3.21-1.222a.5.5 0 0 0-.582-.814c-.658.47-1.666.893-2.765 1.045c-1.097.152-2.236.03-3.193-.529c-1.108-.646-2.227-1.13-3.39-1.276c-1.175-.147-2.365.054-3.6.728a.5.5 0 0 0 .479.878m2.997 1.386c-.961-.12-1.941.038-2.997.614a.5.5 0 0 1-.48-.878c1.236-.674 2.426-.875 3.602-.728c1.162.146 2.281.63 3.39 1.276c.956.558 2.095.681 3.192.53c1.098-.153 2.107-.575 2.765-1.046a.5.5 0 0 1 .582.814c-.8.57-1.963 1.049-3.21 1.222c-1.25.173-2.631.045-3.834-.656c-1.05-.613-2.036-1.025-3.01-1.147"
      />
    </svg>
  );
};
export const IconBasket1 = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M14 18a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m-4 0a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m9-12h-1.38l-1.73-3.45a1 1 0 1 0-1.78.9L15.38 6H8.62l1.27-2.55a1 1 0 0 0-1.78-.9L6.38 6H5a3 3 0 0 0-.92 5.84l.74 7.46a3 3 0 0 0 3 2.7h8.38a3 3 0 0 0 3-2.7l.74-7.46A3 3 0 0 0 19 6m-1.81 13.1a1 1 0 0 1-1 .9H7.81a1 1 0 0 1-1-.9L6.1 12h11.8ZM19 10H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2"
      />
    </svg>
  );
};
export const IconCategory1 = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <circle cx="17" cy="7" r="3" />
        <circle cx="7" cy="17" r="3" />
        <path d="M14 14h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
      </g>
    </svg>
  );
};
export const IconFilter = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M21.25 12H8.895m-4.361 0H2.75m18.5 6.607h-5.748m-4.361 0H2.75m18.5-13.214h-3.105m-4.361 0H2.75m13.214 2.18a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm-9.25 6.607a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm6.607 6.608a2.18 2.18 0 1 0 0-4.361a2.18 2.18 0 0 0 0 4.36Z"
      />
    </svg>
  );
};

export const IconCircle = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
      />
    </svg>
  );
};
export const IconNote = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M16 12a3 3 0 0 1-3-3V5H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6zm-2-3a2 2 0 0 0 2 2h3.59L14 5.41zM5 4h9l7 7v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3m0 4h6v1H5zm0 4h6v1H5zm0 4h13v1H5z"
      />
    </svg>
  );
};
export const IconBell = ({ fillColor }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M12 1.996a7.49 7.49 0 0 1 7.496 7.25l.004.25v4.097l1.38 3.156a1.25 1.25 0 0 1-1.145 1.75L15 18.502a3 3 0 0 1-5.995.177L9 18.499H4.275a1.25 1.25 0 0 1-1.147-1.747L4.5 13.594V9.496c0-4.155 3.352-7.5 7.5-7.5M13.5 18.5l-3 .002a1.5 1.5 0 0 0 2.993.145zM12 3.496c-3.32 0-6 2.674-6 6v4.41L4.656 17h14.697L18 13.907V9.509l-.004-.225A5.99 5.99 0 0 0 12 3.496m9 4.754h2a.75.75 0 0 1 .102 1.493L23 9.75h-2a.75.75 0 0 1-.102-1.493zm-20 0h2a.75.75 0 0 1 .102 1.493L3 9.75H1a.75.75 0 0 1-.102-1.493zm21.6-5.7a.75.75 0 0 1-.066.977l-.084.073l-2 1.5a.75.75 0 0 1-.984-1.127l.084-.073l2-1.5a.75.75 0 0 1 1.05.15M2.45 2.4l2 1.5a.75.75 0 1 1-.9 1.2l-2-1.5a.75.75 0 1 1 .9-1.2"
      />
    </svg>
  );
};
export const IconArrowRight = ({ fillColor, ...props }) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9" {...props}>
      <path
        fill={fillColor}
        d="M12.5 5h-9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9c.28 0 .5.22.5.5s-.22.5-.5.5"
      />
      <path
        fill={fillColor}
        d="M10 8.5a.47.47 0 0 1-.35-.15c-.2-.2-.2-.51 0-.71l3.15-3.15l-3.15-3.15c-.2-.2-.2-.51 0-.71s.51-.2.71 0l3.5 3.5c.2.2.2.51 0 .71l-3.5 3.5c-.1.1-.23.15-.35.15Z"
      />
    </svg>
  );
};

export function IconDelete({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <path
        fill={fillColor}
        d="M20 10.5v.5h8v-.5a4 4 0 0 0-8 0m-2.5.5v-.5a6.5 6.5 0 1 1 13 0v.5h11.25a1.25 1.25 0 1 1 0 2.5h-2.917l-2 23.856A7.25 7.25 0 0 1 29.608 44H18.392a7.25 7.25 0 0 1-7.224-6.644l-2-23.856H6.25a1.25 1.25 0 1 1 0-2.5zm-3.841 26.147a4.75 4.75 0 0 0 4.733 4.353h11.216a4.75 4.75 0 0 0 4.734-4.353L36.324 13.5H11.676zM21.5 20.25a1.25 1.25 0 1 0-2.5 0v14.5a1.25 1.25 0 1 0 2.5 0zM27.75 19c.69 0 1.25.56 1.25 1.25v14.5a1.25 1.25 0 1 1-2.5 0v-14.5c0-.69.56-1.25 1.25-1.25"
      />
    </svg>
  );
}
export function IconLogout({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.496 21H6.5c-1.105 0-2-1.151-2-2.571V5.57c0-1.419.895-2.57 2-2.57h7M16 15.5l3.5-3.5L16 8.5m-6.5 3.496h10"
      />
    </svg>
  );
}
export function IconArrowUp({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M4.284 10.295a1 1 0 0 0 1.424 1.404L11 6.329v13.67a1 1 0 1 0 2 0V6.335l5.285 5.364a1 1 0 0 0 1.424-1.404L12.887 3.37a1.25 1.25 0 0 0-1.78 0z"
      />
    </svg>
  );
}

export function IconArrowDown({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M19.716 13.705a1 1 0 0 0-1.425-1.404l-5.29 5.37V4a1 1 0 1 0-2 0v13.665L5.714 12.3a1 1 0 0 0-1.424 1.403l6.822 6.925a1.25 1.25 0 0 0 1.78 0z"
      />
    </svg>
  );
}

export function IconUserProfile({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25007 2.38782C8.54878 2.0992 10.1243 2 12 2C13.8757 2 15.4512 2.0992 16.7499 2.38782C18.06 2.67897 19.1488 3.176 19.9864 4.01358C20.824 4.85116 21.321 5.94002 21.6122 7.25007C21.9008 8.54878 22 10.1243 22 12C22 13.8757 21.9008 15.4512 21.6122 16.7499C21.321 18.06 20.824 19.1488 19.9864 19.9864C19.1488 20.824 18.06 21.321 16.7499 21.6122C15.4512 21.9008 13.8757 22 12 22C10.1243 22 8.54878 21.9008 7.25007 21.6122C5.94002 21.321 4.85116 20.824 4.01358 19.9864C3.176 19.1488 2.67897 18.06 2.38782 16.7499C2.0992 15.4512 2 13.8757 2 12C2 10.1243 2.0992 8.54878 2.38782 7.25007C2.67897 5.94002 3.176 4.85116 4.01358 4.01358C4.85116 3.176 5.94002 2.67897 7.25007 2.38782ZM12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6ZM18.3775 17.2942C18.7303 17.8695 18.6055 18.63 18.0369 18.9935C17.5199 19.3241 16.9158 19.5265 16.3159 19.6598C15.2322 19.9006 13.8299 20 11.9998 20C10.1698 20 8.76744 19.9006 7.68381 19.6598C7.09516 19.529 6.50205 19.3319 5.99131 19.012C5.41247 18.6495 5.28523 17.8786 5.64674 17.2991C6.06303 16.6318 6.63676 16.1075 7.40882 15.7344C8.58022 15.1684 10.1157 15 11.9996 15C13.8771 15 15.4109 15.1548 16.5807 15.7047C17.3727 16.077 17.9572 16.6089 18.3775 17.2942Z"
        fill={fillColor}
      />
    </svg>
  );
}
export function IconOrderWaiting({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m8.377 31.833c6.917 0 11.667 3.583 15 3.583s10.333-1.916 10.333-17.249-9.417-17.584-13.083-17.584c-17.167 0-24.5 31.25-12.25 31.25z"
        fill="#efefef"
      />
      <path
        d="m24.25 10.75h5v-1.5c0-1.381-1.119-2.5-2.5-2.5-1.381 0-2.5 1.119-2.5 2.5z"
        fill="#9fb1da"
      />
      <path
        d="m24.25 25.54v-16.29c0-1.381 1.119-2.5 2.5-2.5h-15c-1.657 0-3 1.343-3 3v15.792z"
        fill="#f3f3f1"
      />
      <circle cx="23.5" cy="23.5" fill="#9fb1da" r="5.75" />
      <path d="m24.5 24.25-17.75.04v2.96c0 1.1.9 2 2 2h15.75z" fill="#9fb1da" />
      <path
        d="m27.875 7.029c-.34-.172-.718-.279-1.125-.279-1.381 0-2.5 1.119-2.5 2.5v1.5h2.25v-1.5c0-.974.562-1.808 1.375-2.221z"
        fill="#9fb1da"
      />
      <path
        d="m20 23.5c0-2.79 1.988-5.115 4.625-5.638-.364-.072-.74-.112-1.125-.112-3.176 0-5.75 2.574-5.75 5.75s2.574 5.75 5.75 5.75c.385 0 .761-.039 1.125-.112-2.637-.523-4.625-2.848-4.625-5.638z"
        fill="#9fb1da"
      />
      <path
        d="m9 27.25v-2.96l15.5-.035v-.005l-17.75.04v2.96c0 1.1.9 2 2 2h2.25c-1.1 0-2-.9-2-2z"
        fill="#9fb1da"
      />
      <path
        d="m11 9.75c0-1.657 1.343-3 3-3h-2.25c-1.657 0-3 1.343-3 3v14.542h2.25z"
        fill="#d5dbe1"
      />
      <path d="m23.5 30c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
      <path d="m25.427 26.481-2.396-1.917c-.178-.142-.281-.357-.281-.585v-3.354h1.5v2.994l2.115 1.692z" />
      <path d="m11.05 18.5h5.56v1.5h-5.56z" />
      <path d="m11.05 14.5h10.01v1.5h-10.01z" />
      <path d="m11.053 10.5h10.947v1.5h-10.947z" />
      <path d="m9.5 24.292h-1.5v-14.542c0-2.068 1.682-3.75 3.75-3.75h15v1.5h-15c-1.241 0-2.25 1.009-2.25 2.25z" />
      <path d="m29.25 11.5h-5c-.414 0-.75-.336-.75-.75v-1.5c0-1.792 1.458-3.25 3.25-3.25s3.25 1.458 3.25 3.25v1.5c0 .414-.336.75-.75.75zm-4.25-1.5h3.5v-.75c0-.965-.785-1.75-1.75-1.75s-1.75.785-1.75 1.75z" />
      <path d="m16.92 30h-8.17c-1.517 0-2.75-1.233-2.75-2.75v-2.96c0-.414.336-.75.75-.75h8.04v1.5h-7.29v2.21c0 .689.561 1.25 1.25 1.25h8.17z" />
      <path d="m23.5 10.75h1.5v4.04h-1.5z" />
    </svg>
  );
}

export function IconOrderDown({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m27.623 31.833c-6.917 0-11.667 3.583-15 3.583s-10.333-1.916-10.333-17.249 9.417-17.584 13.083-17.584c17.167 0 24.5 31.25 12.25 31.25z"
        fill="#efefef"
      />
      <path
        d="m8.75 29.25c-1.1 0-2-.9-2-2v-15.5c0-1.1.9-2 2-2h12.5c1.1 0 2 .9 2 2v15.5c0 1.105-.895 2-2 2z"
        fill="#f3f3f1"
      />
      <path
        d="m19.25 8.75v2c0 .552-.448 1-1 1h-6.5c-.552 0-1-.448-1-1v-2h2.25c0-1.1.9-2 2-2s2 .9 2 2z"
        fill="#9fb1da"
      />
      <path d="m9.75 14.75h3.5v3.5h-3.5z" fill="#9fb1da" />
      <path d="m9.75 22.75h3.5v3.5h-3.5z" fill="#9fb1da" />
      <circle cx="23.5" cy="23.5" fill="#9fb1da" r="5.75" />
      <g fill="#9fb1da">
        <path d="m16.125 7.1c-.321-.22-.708-.35-1.125-.35-1.1 0-2 .9-2 2h2.25c0-.683.348-1.289.875-1.65z" />
        <path d="m13 10.75v-2h-2.25v2c0 .552.448 1 1 1h2.25c-.552 0-1-.448-1-1z" />
        <path d="m9.75 14.75h2.25v3.5h-2.25z" />
        <path d="m9.75 22.75h2.25v3.5h-2.25z" />
        <path d="m20 23.5c0-2.79 1.988-5.115 4.625-5.638-.364-.072-.74-.112-1.125-.112-3.176 0-5.75 2.574-5.75 5.75s2.574 5.75 5.75 5.75c.385 0 .761-.039 1.125-.112-2.637-.523-4.625-2.848-4.625-5.638z" />
      </g>
      <path
        d="m9 27.25v-15.5c0-1.1.9-2 2-2h-2.25c-1.1 0-2 .9-2 2v15.5c0 1.1.9 2 2 2h2.25c-1.1 0-2-.9-2-2z"
        fill="#d5dbe1"
      />
      <path d="m13.25 19h-3.5c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75h3.5c.414 0 .75.336.75.75v3.5c0 .414-.336.75-.75.75zm-2.75-1.5h2v-2h-2z" />
      <path d="m13.25 27h-3.5c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75h3.5c.414 0 .75.336.75.75v3.5c0 .414-.336.75-.75.75zm-2.75-1.5h2v-2h-2z" />
      <path d="m15.75 14.5h5.5v1.5h-5.5z" />
      <path d="m23.5 30c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
      <path d="m22.5 26.25c-.198 0-.39-.079-.53-.22l-2-2 1.061-1.061 1.434 1.433 2.972-3.396 1.129.987-3.5 4c-.137.156-.332.249-.539.256-.01.001-.019.001-.027.001z" />
      <path d="m24 14.76h-1.5v-3.01c0-.689-.561-1.25-1.25-1.25h-1.88v-1.5h1.88c1.517 0 2.75 1.234 2.75 2.75z" />
      <path d="m16.91 30h-8.16c-1.517 0-2.75-1.233-2.75-2.75v-15.5c0-1.517 1.233-2.75 2.75-2.75h1.88v1.5h-1.88c-.689 0-1.25.561-1.25 1.25v15.5c0 .689.561 1.25 1.25 1.25h8.16z" />
      <path d="m18.25 12.5h-6.5c-.965 0-1.75-.785-1.75-1.75v-2c0-.414.336-.75.75-.75h1.604c.328-1.153 1.39-2 2.646-2s2.318.847 2.646 2h1.604c.414 0 .75.336.75.75v2c0 .965-.785 1.75-1.75 1.75zm-6.75-3v1.25c0 .138.112.25.25.25h6.5c.138 0 .25-.112.25-.25v-1.25h-1.5c-.414 0-.75-.336-.75-.75 0-.689-.561-1.25-1.25-1.25s-1.25.561-1.25 1.25c0 .414-.336.75-.75.75z" />
    </svg>
  );
}
export function IconOrderCancle({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m8.377 4.167c6.917 0 11.667-3.583 15-3.583s10.333 1.916 10.333 17.249-9.417 17.583-13.083 17.583c-17.167.001-24.5-31.249-12.25-31.249z"
        fill="#efefef"
      />
      <path
        d="m27.25 27.25h-18.5c-1.105 0-2-.895-2-2v-15h22.5v15c0 1.105-.895 2-2 2z"
        fill="#f3f3f1"
      />
      <g fill="#9fb1da">
        <path d="m29.25 10.25h-22.5v-1.5c0-1.105.895-2 2-2h18.5c1.105 0 2 .895 2 2z" />
        <path d="m25.25 13.75h-14.5v4.5h14.51z" />
        <circle cx="23.5" cy="23.5" r="5.75" />
      </g>
      <path
        d="m11 6.75h-2.25c-1.105 0-2 .895-2 2v1.5h2.25v-1.5c0-1.105.895-2 2-2z"
        fill="#9fb1da"
      />
      <path d="m10.75 13.75h2.25v4.5h-2.25z" fill="#9fb1da" />
      <path
        d="m20 23.5c0-2.79 1.988-5.115 4.625-5.638-.364-.072-.74-.112-1.125-.112-3.176 0-5.75 2.574-5.75 5.75s2.574 5.75 5.75 5.75c.385 0 .761-.039 1.125-.112-2.637-.523-4.625-2.848-4.625-5.638z"
        fill="#9fb1da"
      />
      <path
        d="m9 25.25v-15h-2.25v15c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z"
        fill="#d5dbe1"
      />
      <path d="m23.5 30c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
      <path
        d="m20.275 22.75h6.45v1.5h-6.45z"
        transform="matrix(.707 -.707 .707 .707 -9.734 23.5)"
      />
      <path
        d="m22.75 20.275h1.5v6.45h-1.5z"
        transform="matrix(.707 -.707 .707 .707 -9.734 23.5)"
      />
      <path d="m16.51 19h-5.76c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75v1.18h-1.5v-.43h-13v3h5.01z" />
      <path d="m10.05 20.49h5.75v1.5h-5.75z" />
      <path d="m10.05 23.49h5.49v1.5h-5.49z" />
      <path d="m15.59 28h-6.84c-1.517 0-2.75-1.233-2.75-2.75v-16.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v8.17h-1.5v-8.17c0-.689-.561-1.25-1.25-1.25h-18.5c-.689 0-1.25.561-1.25 1.25v16.5c0 .689.561 1.25 1.25 1.25h6.84z" />
      <path d="m6.75 9.5h22.5v1.5h-22.5z" />
    </svg>
  );
}

export function IconOrderAll({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m31.833 8.377c0 6.917 3.583 11.667 3.583 15s-1.916 10.333-17.249 10.333-17.584-9.417-17.584-13.083c0-17.167 31.25-24.5 31.25-12.25z"
        fill="#efefef"
      />
      <path
        d="m26.25 9.75h-11.5c-1.105 0-2 .895-2 2v15.5c0 1.105.895 2 2 2h11.5c1.105 0 2-.895 2-2v-15.5c0-1.105-.895-2-2-2z"
        fill="#f3f3f1"
      />
      <path d="m15.75 14h3.5v3.5h-3.5z" fill="#9fb1da" />
      <path d="m15.75 14h2.25v3.5h-2.25z" fill="#9fb1da" />
      <path
        d="m15 27.25v-15.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v15.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z"
        fill="#d5dbe1"
      />
      <path d="m26.25 30h-11.5c-1.517 0-2.75-1.233-2.75-2.75v-15.5c0-1.517 1.233-2.75 2.75-2.75h11.5c1.517 0 2.75 1.233 2.75 2.75v15.5c0 1.517-1.233 2.75-2.75 2.75zm-11.5-19.5c-.689 0-1.25.561-1.25 1.25v15.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25v-15.5c0-.689-.561-1.25-1.25-1.25z" />
      <path d="m19.25 18.25h-3.5c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75h3.5c.414 0 .75.336.75.75v3.5c0 .414-.336.75-.75.75zm-2.75-1.5h2v-2h-2z" />
      <path d="m21.75 16.5h4.5v1.5h-4.5z" />
      <path d="m21.75 13.5h4.5v1.5h-4.5z" />
      <path d="m15 24.5h11v1.5h-11z" />
      <path d="m15 20.5h11v1.5h-11z" />
      <path d="m9.75 27c-1.517 0-2.75-1.233-2.75-2.75v-15.5c0-1.517 1.233-2.75 2.75-2.75h11.5v1.5h-11.5c-.689 0-1.25.561-1.25 1.25v15.5c0 .689.561 1.25 1.25 1.25z" />
    </svg>
  );
}

export function IconOrder({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <g>
        <g>
          <rect x="111.999" y="176" width="192" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="111.999" y="224" width="192" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="111.999" y="272" width="192" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="111.999" y="320" width="96" height="16" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="208.239" cy="48" r="12" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M367.998,95.999c0-17.673-14.326-32-31.999-32h-44.424c-5.926-6.583-13.538-11.62-22.284-14.136
			c-7.367-2.118-13.037-7.788-15.156-15.155C248.37,14.664,229.897,0,207.998,0c-21.898,0-40.37,14.663-46.134,34.706
			c-2.122,7.376-7.806,13.039-15.182,15.165c-8.736,2.518-16.341,7.55-22.262,14.128H79.999c-17.674,0-32,14.327-32,32v287.999
			c0,17.673,14.326,32,32,32c73.466,0,163.758,0,256,0c17.674,0,32-14.327,32-32C367.999,293.119,367.998,206.096,367.998,95.999z
			 M128,95.741c0.11-14.066,9.614-26.606,23.113-30.496c12.71-3.662,22.477-13.426,26.127-26.116
			C181.157,25.51,193.805,16,207.998,16c14.194,0,26.842,9.51,30.758,23.13c3.652,12.698,13.413,22.459,26.111,26.11
			c13.618,3.917,23.13,16.566,23.13,30.758v16H128V95.741z M335.999,399.998c-85.455,0-170.77,0-256,0c-8.823,0-16-7.178-16-16
			V95.999c0-8.822,7.177-16,16-16h34.742c-1.73,4.892-2.698,10.143-2.74,15.617v32.383h191.998v-32c0-5.615-0.992-10.991-2.764-16
			h34.764c8.822,0,15.999,7.178,15.999,16c0,45.743-0.001,260.254,0.002,287.999C351.999,392.82,344.822,399.998,335.999,399.998z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function IconWalletTransition({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m31.833 27.623c0-6.917 3.583-11.667 3.583-15s-1.916-10.333-17.249-10.333-17.584 9.417-17.584 13.083c0 17.167 31.25 24.5 31.25 12.25z"
        fill="#efefef"
      />
      <path
        d="m26.25 8.75v18.5c0 1.1-.9 2-2 2h-9.5v-3c0-1.1-.9-2-2-2h-3v-15.5c0-1.1.9-2 2-2h12.5c1.1 0 2 .9 2 2z"
        fill="#f3f3f1"
      />
      <path d="m14.75 26.25v3l-5-5h3c1.1 0 2 .9 2 2z" fill="#9fb1da" />
      <path
        d="m22.25 13.25h-8.5c-.552 0-1-.448-1-1v-1.5c0-.552.448-1 1-1h8.5c.552 0 1 .448 1 1v1.5c0 .552-.448 1-1 1z"
        fill="#9fb1da"
      />
      <path
        d="m14 6.75h-2.25c-1.1 0-2 .9-2 2v15.5h2.25v-15.5c0-1.1.9-2 2-2z"
        fill="#d5dbe1"
      />
      <path d="m12 24.25h-2.25l5 5v-2.25z" fill="#9fb1da" />
      <path
        d="m15 12.25v-1.5c0-.552.448-1 1-1h-2.25c-.552 0-1 .448-1 1v1.5c0 .552.448 1 1 1h2.25c-.552 0-1-.448-1-1z"
        fill="#9fb1da"
      />
      <path d="m15.5 29.25h-1.5v-3c0-.689-.561-1.25-1.25-1.25h-3v-1.5h3c1.517 0 2.75 1.233 2.75 2.75z" />
      <path d="m24.25 30h-9.5c-.199 0-.39-.079-.53-.22l-5-5c-.141-.14-.22-.331-.22-.53v-15.5c0-1.517 1.233-2.75 2.75-2.75h12.5c1.517 0 2.75 1.233 2.75 2.75v18.5c0 1.517-1.233 2.75-2.75 2.75zm-9.189-1.5h9.189c.689 0 1.25-.561 1.25-1.25v-18.5c0-.689-.561-1.25-1.25-1.25h-12.5c-.689 0-1.25.561-1.25 1.25v15.189z" />
      <path d="m22.25 14h-8.5c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.965.785-1.75 1.75-1.75h8.5c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75zm-8.5-3.5c-.138 0-.25.112-.25.25v1.5c0 .138.112.25.25.25h8.5c.138 0 .25-.112.25-.25v-1.5c0-.138-.112-.25-.25-.25z" />
      <path d="m13 16h10v1.5h-10z" />
      <path d="m13 19.5h10v1.5h-10z" />
    </svg>
  );
}
export function IconWalletDeposit({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m4.167 27.623c0-6.917-3.583-11.667-3.583-15s1.916-10.333 17.249-10.333 17.583 9.417 17.583 13.083c.001 17.167-31.249 24.5-31.249 12.25z"
        fill="#efefef"
      />
      <path
        d="m29.25 24.25v-12.5c0-1.105-.895-2-2-2h-18.5c-1.105 0-2 .895-2 2v12.5c0 1.105.895 2 2 2h18.5c1.105 0 2-.895 2-2z"
        fill="#f3f3f1"
      />
      <path
        d="m6.75 21.25h6.5c1.105 0 2-.895 2-2v-2.5c0-1.105-.895-2-2-2h-6.5z"
        fill="#9fb1da"
      />
      <path
        d="m29.25 23.5-4.75-4.75-4.75 4.75h3v5.25c0 .276.224.5.5.5h2.5c.276 0 .5-.224.5-.5v-5.25z"
        fill="#9fb1da"
      />
      <path
        d="m9 24.25v-12.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v12.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z"
        fill="#d5dbe1"
      />
      <path d="m6.75 14.75h2.25v6.5h-2.25z" fill="#9fb1da" />
      <path d="m24.5 18.75-4.75 4.75h2.25l3.625-3.625z" fill="#9fb1da" />
      <path
        d="m25 28.75v-5.25h-2.25v5.25c0 .276.224.5.5.5h2.25c-.276 0-.5-.224-.5-.5z"
        fill="#9fb1da"
      />
      <path d="m25.75 30h-2.5c-.689 0-1.25-.561-1.25-1.25v-4.5h-2.25c-.303 0-.577-.183-.693-.463s-.052-.603.163-.817l4.75-4.75c.293-.293.768-.293 1.061 0l4.75 4.75c.214.215.279.537.163.817s-.39.463-.693.463h-2.251v4.5c0 .689-.561 1.25-1.25 1.25zm-2.25-1.5h2v-5c0-.414.336-.75.75-.75h1.189l-2.939-2.939-2.939 2.939h1.189c.414 0 .75.336.75.75z" />
      <path d="m17.25 27h-8.5c-1.517 0-2.75-1.233-2.75-2.75v-12.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v6.5h-1.5v-6.5c0-.689-.561-1.25-1.25-1.25h-18.5c-.689 0-1.25.561-1.25 1.25v12.5c0 .689.561 1.25 1.25 1.25h8.5z" />
      <path d="m13.25 22h-6.5c-.414 0-.75-.336-.75-.75v-6.5c0-.414.336-.75.75-.75h6.5c1.517 0 2.75 1.233 2.75 2.75v2.5c0 1.517-1.233 2.75-2.75 2.75zm-5.75-1.5h5.75c.689 0 1.25-.561 1.25-1.25v-2.5c0-.689-.561-1.25-1.25-1.25h-5.75z" />
      <circle cx="11" cy="18" r="1" />
    </svg>
  );
}
export function IconWalletWithdraw({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m31.833 27.623c0-6.917 3.583-11.667 3.583-15s-1.916-10.333-17.249-10.333-17.584 9.417-17.584 13.083c0 17.167 31.25 24.5 31.25 12.25z"
        fill="#efefef"
      />
      <path
        d="m29.25 24.25v-12.5c0-1.105-.895-2-2-2h-18.5c-1.105 0-2 .895-2 2v12.5c0 1.105.895 2 2 2h18.5c1.105 0 2-.895 2-2z"
        fill="#f3f3f1"
      />
      <path
        d="m6.75 21.25h6.5c1.105 0 2-.895 2-2v-2.5c0-1.105-.895-2-2-2h-6.5z"
        fill="#9fb1da"
      />
      <path
        d="m29.25 24.5-4.75 4.75-4.75-4.75h3v-5.25c0-.276.224-.5.5-.5h2.5c.276 0 .5.224.5.5v5.25z"
        fill="#9fb1da"
      />
      <path
        d="m9 24.25v-12.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v12.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z"
        fill="#d5dbe1"
      />
      <g fill="#9fb1da">
        <path d="m6.75 14.75h2.25v6.5h-2.25z" />
        <path d="m25 19.25c0-.276.224-.5.5-.5h-2.25c-.276 0-.5.224-.5.5v5.25h2.25z" />
        <path d="m22 24.5h-2.25l4.75 4.75 1.125-1.125z" />
      </g>
      <path d="m24.5 30c-.192 0-.384-.073-.53-.22l-4.75-4.75c-.215-.215-.278-.537-.163-.817.116-.28.39-.463.693-.463h2.25v-4.5c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25v4.5h2.25c.304 0 .577.183.693.463.115.28.052.603-.163.817l-4.75 4.75c-.146.147-.338.22-.53.22zm-2.939-4.75 2.939 2.939 2.939-2.939h-1.189c-.414 0-.75-.336-.75-.75v-5h-2v5c0 .414-.336.75-.75.75z" />
      <path d="m17.25 27h-8.5c-1.517 0-2.75-1.233-2.75-2.75v-12.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v4.5h-1.5v-4.5c0-.689-.561-1.25-1.25-1.25h-18.5c-.689 0-1.25.561-1.25 1.25v12.5c0 .689.561 1.25 1.25 1.25h8.5z" />
      <path d="m13.25 22h-6.5c-.414 0-.75-.336-.75-.75v-6.5c0-.414.336-.75.75-.75h6.5c1.517 0 2.75 1.233 2.75 2.75v2.5c0 1.517-1.233 2.75-2.75 2.75zm-5.75-1.5h5.75c.689 0 1.25-.561 1.25-1.25v-2.5c0-.689-.561-1.25-1.25-1.25h-5.75z" />
      <circle cx="11" cy="18" r="1" />
    </svg>
  );
}
export function IconWalletRequest({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="m27.623 31.833c-6.917 0-11.667 3.583-15 3.583s-10.333-1.916-10.333-17.249 9.417-17.584 13.083-17.584c17.167 0 24.5 31.25 12.25 31.25z"
        fill="#efefef"
      />
      <path
        d="m22.25 27.25c0 1.105-.895 2-2 2h-10.5c-1.105 0-2-.895-2-2v-18.5c0-1.105.895-2 2-2h10.5c1.105 0 2 .895 2 2z"
        fill="#f3f3f1"
      />
      <path
        d="m28.25 15.75v1h-13.5v-1c0-1.1.9-2 2-2h9.5c1.1 0 2 .9 2 2z"
        fill="#f3f3f1"
      />
      <path
        d="m9.75 6.75h.5c.828 0 1.5.672 1.5 1.5 0 .552.448 1 1 1h4.5c.552 0 1-.448 1-1 0-.828.672-1.5 1.5-1.5h.5z"
        fill="#9fb1da"
      />
      <path
        d="m28.25 16.75v3.5c0 1.1-.9 2-2 2h-9.5c-1.1 0-2-.9-2-2v-3.5z"
        fill="#9fb1da"
      />
      <path
        d="m10 27.25v-18.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v18.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z"
        fill="#d5dbe1"
      />
      <path
        d="m19 13.75h-2.25c-1.1 0-2 .9-2 2v1h2.25v-1c0-1.1.9-2 2-2z"
        fill="#d5dbe1"
      />
      <path
        d="m14 8.25c0-.828-.672-1.5-1.5-1.5h-.5-1.75c.828 0 1.5.672 1.5 1.5 0 .552.448 1 1 1h2.25c-.552 0-1-.448-1-1z"
        fill="#9fb1da"
      />
      <path
        d="m17 20.25v-3.5h-2.25v3.5c0 1.1.9 2 2 2h2.25c-1.1 0-2-.9-2-2z"
        fill="#9fb1da"
      />
      <path d="m17.25 10h-4.5c-.965 0-1.75-.785-1.75-1.75 0-.413-.337-.75-.75-.75h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c1.24 0 2.25 1.01 2.25 2.25 0 .138.112.25.25.25h4.5c.138 0 .25-.112.25-.25 0-1.24 1.01-2.25 2.25-2.25h.5c.414 0 .75.336.75.75s-.336.75-.75.75h-.5c-.413 0-.75.337-.75.75 0 .965-.785 1.75-1.75 1.75z" />
      <path d="m20.25 30h-10.5c-1.517 0-2.75-1.233-2.75-2.75v-18.5c0-1.517 1.233-2.75 2.75-2.75h10.5c1.517 0 2.75 1.233 2.75 2.75v1.5h-1.5v-1.5c0-.689-.561-1.25-1.25-1.25h-10.5c-.689 0-1.25.561-1.25 1.25v18.5c0 .689.561 1.25 1.25 1.25h10.5c.689 0 1.25-.561 1.25-1.25v-1.438h1.5v1.438c0 1.517-1.233 2.75-2.75 2.75z" />
      <path d="m26.25 23h-9.5c-1.517 0-2.75-1.233-2.75-2.75v-4.5c0-1.517 1.233-2.75 2.75-2.75h9.5c1.517 0 2.75 1.233 2.75 2.75v4.5c0 1.517-1.233 2.75-2.75 2.75zm-9.5-8.5c-.689 0-1.25.561-1.25 1.25v4.5c0 .689.561 1.25 1.25 1.25h9.5c.689 0 1.25-.561 1.25-1.25v-4.5c0-.689-.561-1.25-1.25-1.25z" />
      <path d="m28.25 17.5h-13.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h13.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
    </svg>
  );
}

export function IconWallet1({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M437.333,137.533H74.667C33.493,137.533,0,171.026,0,212.199v213.333c0,41.173,33.493,74.667,74.667,74.667h362.667
			c41.173,0,74.667-33.493,74.667-74.667V212.199C512,171.026,478.507,137.533,437.333,137.533z M490.667,425.533
			c0,29.397-23.915,53.333-53.333,53.333H74.667c-29.419,0-53.333-23.936-53.333-53.333V212.199
			c0-29.397,23.915-53.333,53.333-53.333h362.667c29.419,0,53.333,23.936,53.333,53.333V425.533z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M416,286.866c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32
			C448,301.223,433.643,286.866,416,286.866z M416,329.533c-5.867,0-10.667-4.779-10.667-10.667s4.8-10.667,10.667-10.667
			c5.867,0,10.667,4.779,10.667,10.667S421.867,329.533,416,329.533z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M501.333,244.199H416c-41.173,0-74.667,33.493-74.667,74.667c0,41.173,33.493,74.667,74.667,74.667h85.333
			c5.888,0,10.667-4.779,10.667-10.667v-128C512,248.978,507.221,244.199,501.333,244.199z M490.667,372.199H416
			c-29.419,0-53.333-23.936-53.333-53.333c0-29.397,23.915-53.333,53.333-53.333v0h74.667V372.199z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M436.203,143.421L391.04,53.095c-9.109-18.219-24.832-31.637-44.245-37.781c-19.413-6.123-39.979-4.203-57.941,5.44
			L69.611,138.813c-5.184,2.773-7.125,9.259-4.331,14.443c2.795,5.184,9.28,7.125,14.443,4.331L299.008,39.57
			c12.8-6.912,27.541-8.299,41.365-3.904c13.867,4.373,25.088,13.973,31.595,26.987l45.163,90.325
			c1.877,3.733,5.632,5.888,9.536,5.888c1.6,0,3.221-0.363,4.757-1.131C436.693,155.09,438.827,148.69,436.203,143.421z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M393.408,57.831c-2.816-5.205-9.301-7.125-14.464-4.352l-158.485,85.333c-5.184,2.795-7.125,9.259-4.331,14.443
			c1.92,3.584,5.589,5.611,9.387,5.611c1.707,0,3.456-0.405,5.077-1.259l158.485-85.333
			C394.261,69.479,396.203,63.015,393.408,57.831z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M192,73.533h-74.667C52.651,73.533,0,126.162,0,190.866v21.333c0,5.888,4.779,10.667,10.667,10.667
			s10.667-4.779,10.667-10.667v-21.333c0-52.928,43.072-96,96-96H192c5.888,0,10.667-4.779,10.667-10.667S197.888,73.533,192,73.533
			z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M394.667,73.533c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667c52.928,0,96,43.072,96,96v21.333
			c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667v-21.333C512,126.162,459.349,73.533,394.667,73.533z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function IconClose({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M4.28 3.22a.75.75 0 0 0-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 1 0 1.06 1.06L8 9.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L9.06 8l3.72-3.72a.75.75 0 0 0-1.06-1.06L8 6.94z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export function IconErrorCircle({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        fill={fillColor}
        d="M18 6a12 12 0 1 0 12 12A12 12 0 0 0 18 6m0 22a10 10 0 1 1 10-10a10 10 0 0 1-10 10"
        className="clr-i-outline clr-i-outline-path-1"
      />
      <path
        fill={fillColor}
        d="M18 20.07a1.3 1.3 0 0 1-1.3-1.3v-6a1.3 1.3 0 1 1 2.6 0v6a1.3 1.3 0 0 1-1.3 1.3"
        className="clr-i-outline clr-i-outline-path-2"
      />
      <circle
        cx="17.95"
        cy="23.02"
        r="1.5"
        fill={fillColor}
        className="clr-i-outline clr-i-outline-path-3"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
}
export function IconNoTicket({ fillColor }) {
  return (
    <svg className="icon"
      viewBox="0 0 40.7 40.6"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="st0"
        d="M9.9,21.7v-9.5h22V33h-22v-3.4c0-0.2-0.1-0.4-0.3-0.5c-0.2,0-0.4,0.1-0.5,0.3c0,0,0,0.1,0,0.1v3.8
	c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h22.8c0.2,0,0.4-0.2,0.4-0.4V7.8c0-0.2-0.2-0.4-0.4-0.4H9.5c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0
	v13.9c0,0.2,0.1,0.4,0.3,0.5s0.4-0.1,0.5-0.3C9.9,21.8,9.9,21.7,9.9,21.7L9.9,21.7z M9.9,8.2h22v3.2h-22V8.2z"
      />
      <path
        className="st0"
        d="M30.9,9.5c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1
	c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C31.3,9.4,31,9.4,30.9,9.5z"
      />
      <path
        className="st0"
        d="M28.6,9.8c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4
	C28.7,9.4,28.6,9.6,28.6,9.8z"
      />
      <path
        className="st0"
        d="M26.5,9.5c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1
	c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C26.9,9.4,26.6,9.4,26.5,9.5z"
      />
      <path
        className="st0"
        d="M13.3,15.4v1.6c0,0.4,0.4,0.8,0.8,0.8h1.6c0.4,0,0.8-0.4,0.8-0.8v-1.6c0-0.4-0.3-0.8-0.8-0.8h-1.6
	C13.7,14.7,13.3,15,13.3,15.4z M15.7,17.1h-1.6v-1.6h1.6V17.1z"
      />
      <path
        className="st0"
        d="M14.1,29.7c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h1.6c0.4,0,0.8-0.4,0.8-0.8v-1.6c0-0.4-0.4-0.8-0.8-0.8
	c0,0,0,0,0,0h-0.8c-0.2,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.3,0.4,0.4h0.8v1.6L14.1,29.7z"
      />
      <path
        className="st0"
        d="M30.5,14.7h-3.2c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h3.2
	c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0C30.9,14.8,30.7,14.7,30.5,14.7z"
      />
      <path
        className="st0"
        d="M19,14.7c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h6c0.2,0,0.4-0.2,0.4-0.4
	c0,0,0,0,0,0c0-0.2-0.2-0.4-0.4-0.4c0,0,0,0,0,0H19z"
      />
      <path
        className="st0"
        d="M23.3,17.4c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h4.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-4.4
	C23.5,17.1,23.3,17.2,23.3,17.4C23.3,17.4,23.3,17.4,23.3,17.4z"
      />
      <path
        className="st0"
        d="M19,17.8h2.8c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H19c-0.2,0-0.4,0.2-0.4,0.4
	C18.6,17.7,18.7,17.8,19,17.8z"
      />
      <path
        className="st0"
        d="M30.5,21h-7.2c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h7.2
	c0.2,0,0.4-0.2,0.4-0.4C30.9,21.1,30.7,21,30.5,21C30.5,21,30.5,21,30.5,21z"
      />
      <path
        className="st0"
        d="M19,21.8h1.9c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c0,0,0,0,0,0H19c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0
	C18.6,21.6,18.7,21.8,19,21.8C18.9,21.8,19,21.8,19,21.8z"
      />
      <path
        className="st0"
        d="M27.7,23.8c0-0.2-0.2-0.4-0.4-0.4c0,0,0,0,0,0h-2c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2
	C27.5,24.2,27.7,24,27.7,23.8C27.7,23.8,27.7,23.8,27.7,23.8z"
      />
      <path
        className="st0"
        d="M19,24.2h4.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H19c-0.2,0-0.4,0.2-0.4,0.4
	C18.6,24,18.7,24.2,19,24.2z"
      />
      <path
        className="st0"
        d="M24.2,27.7c0,0.2,0.2,0.4,0.4,0.4h6c0.2,0,0.4-0.2,0.4-0.5c0-0.2-0.2-0.3-0.4-0.4h-6
	C24.3,27.3,24.2,27.5,24.2,27.7z"
      />
      <path
        className="st0"
        d="M19,28.1h3.2c0.2,0,0.4-0.1,0.5-0.4c0-0.2-0.1-0.4-0.4-0.5c0,0-0.1,0-0.1,0H19c-0.2,0-0.4,0.2-0.4,0.5
	C18.6,27.9,18.8,28.1,19,28.1z"
      />
      <path
        className="st0"
        d="M19,30.5h6.8c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H19c-0.2,0-0.4,0.2-0.4,0.4S18.7,30.5,19,30.5z"
      />
      <path
        className="st0"
        d="M10.6,26.8L12,30c0.1,0.1,0.2,0.2,0.4,0.2l0,0c0.2,0,0.3-0.1,0.4-0.3l1.7-5h1.6c0.7,0,1.2-0.5,1.2-1.2
	c0,0,0,0,0,0v-2.4c0-0.7-0.5-1.2-1.2-1.2h-2.4c-0.7,0-1.2,0.5-1.2,1.2V23l-5,1.7c-0.2,0.1-0.3,0.3-0.2,0.5c0,0.1,0.1,0.2,0.2,0.2
	L10.6,26.8z M13.3,21.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h2.4c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0v2.4c0,0.2-0.2,0.4-0.4,0.4h-1.3
	l0.5-1.5c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4-0.1l-1.5,0.5L13.3,21.4z M14.2,23.2l-1.9,5.6l-1-2.4c0-0.1-0.1-0.2-0.2-0.2
	l-2.4-1L14.2,23.2z"
      />
      <circle className="st1" cx="20.2" cy="20.5" r="19.1" />
      <line className="st1" x1="33.7" y1="6.3" x2="7.3" y2="33.6" />
    </svg>
  );
}
export function IconCancelTicket({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 8v.5m0 7v.5m-9 1v-3a2 2 0 1 0 0-4V7a2 2 0 0 1 2-2h10M5 19h14a2 2 0 0 0 2-2v-3a2 2 0 1 1 0-4V7a2 2 0 0 0-2-2M3 21L21 3"
      />
    </svg>
  );
}
export function IconLocation({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(4 2)"
      >
        <path d="m6.5 16.54l.631-.711c.716-.82 1.36-1.598 1.933-2.338l.473-.624c1.975-2.661 2.963-4.773 2.963-6.334C12.5 3.201 9.814.5 6.5.5s-6 2.701-6 6.033c0 1.561.988 3.673 2.963 6.334l.473.624a54.84 54.84 0 0 0 2.564 3.05" />
        <circle cx="6.5" cy="6.5" r="2.5" />
      </g>
    </svg>
  );
}
export function IconCheck({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fill={fillColor}
        d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.75.75 0 0 1 .018-1.042a.75.75 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0"
      />
    </svg>
  );
}
export function IconCheckCircle({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path
        d="M499.2 951.466667c-234.666667 0-426.666667-192-426.666667-426.666667 0-17.066667 0-38.4 4.266667-55.466667 4.266667-12.8 12.8-17.066667 25.6-17.066666 12.8 4.266667 17.066667 12.8 17.066667 25.6-4.266667 12.8-4.266667 29.866667-4.266667 46.933333 0 213.333333 170.666667 384 384 384s384-170.666667 384-384-170.666667-384-384-384c-25.6 0-46.933333 4.266667-72.533333 8.533333-12.8 0-21.333333-4.266667-25.6-17.066666 0-12.8 4.266667-21.333333 17.066666-25.6 25.6-4.266667 51.2-8.533333 81.066667-8.533334 234.666667 0 426.666667 192 426.666667 426.666667s-192 426.666667-426.666667 426.666667z"
        fill={fillColor}
      />
      <path
        d="M119.466667 418.133333h-8.533334c-8.533333-4.266667-17.066667-17.066667-12.8-29.866666 42.666667-119.466667 128-213.333333 238.933334-256 12.8-4.266667 21.333333 0 25.6 12.8 4.266667 12.8 0 21.333333-12.8 25.6C256 213.333333 174.933333 298.666667 140.8 405.333333c-4.266667 8.533333-12.8 12.8-21.333333 12.8z"
        fill={fillColor}
      />
      <path
        d="M477.866667 657.066667c-4.266667 0-12.8 0-17.066667-4.266667-8.533333-8.533333-8.533333-21.333333 0-29.866667l213.333333-213.333333c8.533333-8.533333 21.333333-8.533333 29.866667 0s8.533333 21.333333 0 29.866667l-213.333333 213.333333c0 4.266667-8.533333 4.266667-12.8 4.266667z"
        fill={fillColor}
      />
      <path
        d="M477.866667 657.066667c-4.266667 0-12.8 0-17.066667-4.266667l-93.866667-93.866667c-8.533333-8.533333-8.533333-21.333333 0-29.866666s21.333333-8.533333 29.866667 0l93.866667 93.866666c8.533333 8.533333 8.533333 21.333333 0 29.866667 0 4.266667-8.533333 4.266667-12.8 4.266667z"
        fill={fillColor}
      />
    </svg>
  );
}
export function IconEmptyBasket({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.42 99.73">
      <g className="cls-1">
        <path
          className="cls-2"
          d="m36.06 76.41l-12.65 0c-1.4 0-3 0-2.86-2 0.13-1.73 1.73-1.42 2.89-1.43q13.06 0 26.12 0c1.18 0 2.74-0.24 2.85 1.49 0.13 2-1.51 1.9-2.88 1.9 -4.53 0.05-8.98 0.05-13.47 0.04z"
        ></path>
        <path
          className="cls-2"
          d="m53.91 87.12c-2 0-4.08 0-6.11 0 -1 0-1.91-0.44-1.82-1.68a1.52 1.52 0 0 1 1.7-1.44q6.52-0.05 13 0c1 0 2 0.45 1.83 1.67s-1.1 1.42-2.12 1.42l-6.48 0 0 0.03z"
        ></path>
        <path
          className="cls-2"
          d="m33.74 99.33c-2 0-4.06 0-6.09 0 -0.88 0-1.66-0.36-1.76-1.3s0.7-1.46 1.55-1.47q6.29-0.06 12.58 0c0.78 0 1.71 0.22 1.76 1.27 0.05 1.32-1 1.46-2 1.48 -1.98 0.05-4.01 0.02-6.04 0.02z"
        ></path>
        <path
          className="cls-2"
          d="m39.2 87.15c-1.19-0.06-2.71 0.08-2.66-1.6s1.56-1.55 2.75-1.55 2.7-0.11 2.65 1.6 -1.56 1.49-2.74 1.55z"
        ></path>
        <path
          className="cls-2"
          d="m2.54 73.56c1.36 0.23 3.11-0.23 3 1.59s-1.83 1.22-3 1.24 -2.49 0.32-2.54-1.25c-0.06-1.97 1.76-1.14 2.54-1.58z"
        ></path>
        <path
          className="cls-2"
          d="m16.8 96.48c1 0.11 2.35-0.09 2.32 1.47 0 1.18-1.06 1.39-2.05 1.38s-2.32 0-2.34-1.48c-0.01-1.3 1.12-1.26 2.07-1.37z"
        ></path>
        <path
          className="cls-2"
          d="m12.92 76.44c-1.23-0.11-2-0.68-2-1.73 0-1.33 0.93-1.86 2.13-1.78a1.62 1.62 0 0 1 1.63 1.87 1.71 1.71 0 0 1-1.76 1.64z"
        ></path>
        <path
          className="cls-2"
          d="m149.36 76.8l12.64 0c1.4 0 3 0 2.86-2 -0.13-1.73-1.73-1.42-2.89-1.43q-13.06 0-26.12 0c-1.18 0-2.74-0.24-2.85 1.49 -0.13 2 1.51 1.9 2.88 1.9 4.5 0.05 8.99 0.04 13.48 0.04z"
        ></path>
        <path
          className="cls-2"
          d="m131.51 87.5c2 0 4.08 0 6.11 0 1 0 1.91-0.44 1.82-1.68a1.52 1.52 0 0 0-1.71-1.38q-6.52-0.05-13 0c-1 0-2 0.45-1.83 1.67s1.1 1.42 2.12 1.42l6.52 0 -0.03-0.03z"
        ></path>
        <path
          className="cls-2"
          d="m151.68 99.71c2 0 4.06 0 6.09 0 0.88 0 1.66-0.36 1.76-1.3s-0.7-1.46-1.55-1.47q-6.29-0.06-12.58 0c-0.78 0-1.71 0.22-1.76 1.27 -0.05 1.32 1 1.46 2 1.48 1.98 0.06 4.01 0.03 6.04 0.02z"
        ></path>
        <path
          className="cls-2"
          d="m146.22 87.54c1.19-0.06 2.71 0.08 2.66-1.6s-1.56-1.54-2.75-1.53 -2.7-0.11-2.65 1.6 1.52 1.47 2.74 1.53z"
        ></path>
        <path
          className="cls-2"
          d="m182.88 74c-1.36 0.23-3.11-0.23-3 1.59s1.83 1.22 3 1.24 2.49 0.32 2.54-1.26c0.06-2.01-1.76-1.18-2.54-1.57z"
        ></path>
        <path
          className="cls-2"
          d="m168.62 96.87c-1 0.11-2.35-0.09-2.32 1.47 0 1.18 1.06 1.39 2.05 1.38s2.32 0 2.34-1.48c0.01-1.3-1.12-1.24-2.07-1.37z"
        ></path>
        <path
          className="cls-2"
          d="m172.5 76.83c1.23-0.11 2-0.68 2-1.73 0-1.33-0.93-1.86-2.13-1.78a1.62 1.62 0 0 0-1.63 1.87 1.71 1.71 0 0 0 1.76 1.64z"
        ></path>
        <text
          className="cls-3"
          transform="matrix(0.95 0.31 -0.31 0.95 134.5 48.15)"
        >
          {" "}
          +
        </text>
        <text
          className="cls-4"
          transform="rotate(-10 60 17)"
          y="17.05"
          x="60.6"
        >
          +
        </text>
        <text className="cls-5" y="40.9" x="32.21">
          +
        </text>
        <polygon
          className="cls-6"
          points="57.99 37.43 54.68 44.38 50.55 37.66 57.99 37.43"
        ></polygon>
        <polygon
          className="cls-6"
          points="105.31 20.91 105.41 13.21 111.97 17.58 105.31 20.91"
        ></polygon>
        <circle className="cls-7" cx="29.13" cy="53.5" r="3.41"></circle>
        <circle className="cls-7" cx="21.55" cy="86.1" r="3.41"></circle>
        <circle
          className="cls-7"
          cx="78.09"
          cy="43.97"
          r="2.09"
          transform="rotate(-16 -2 23)"
        ></circle>
        <circle
          className="cls-7"
          cx="119.35"
          cy="50.83"
          r="2.09"
          transform="rotate(-16 0 33)"
        ></circle>
        <g className="a">
          <g className="a">
            <path
              className="st0"
              d="m115.915 41.909c-0.697-0.813-1.713-1.278-2.788-1.278l-35.426 0c-0.581 0-1.045 0.465-1.045 1.045s0.465 1.045 1.045 1.045l35.426 0c0.465 0 0.929 0.203 1.22 0.552 0.29 0.348 0.436 0.813 0.377 1.278l-3.397 14.955c0 0.029 0 0.058 0 0.058 -0.203 1.249-1.307 2.178-2.555 2.178l-24.16 0c-0.581 0-1.045 0.465-1.045 1.045 0 0.581 0.465 1.045 1.045 1.045l24.16 0c2.294 0 4.211-1.626 4.588-3.891l3.397-14.955c0-0.029 0-0.058 0-0.058 0.174-1.103-0.145-2.178-0.842-3.02l0 0z"
            ></path>
            <path
              className="st0"
              d="m82.957 73.618c-2.671 0-4.849 2.178-4.849 4.849 0 2.672 2.178 4.849 4.849 4.849 2.672 0 4.849-2.178 4.849-4.849 0-2.671-2.178-4.849-4.849-4.849zm0 7.637c-1.539 0-2.788-1.249-2.788-2.788 0-1.539 1.249-2.788 2.788-2.788 1.539 0 2.788 1.249 2.788 2.788 0 1.539-1.249 2.788-2.788 2.788z"
            ></path>
            <path
              className="st0"
              d="m104.503 73.618c-2.671 0-4.849 2.178-4.849 4.849 0 2.672 2.178 4.849 4.849 4.849 2.672 0 4.849-2.178 4.849-4.849 0-2.671-2.178-4.849-4.849-4.849zm0 7.637c-1.539 0-2.788-1.249-2.788-2.788 0-1.539 1.249-2.788 2.788-2.788 1.539 0 2.788 1.249 2.788 2.788 0 1.539-1.249 2.788-2.788 2.788z"
            ></path>
            <path
              className="st0"
              d="m108.336 68.885l-28.893 0 -2.701-10.599 -5.256-22.737c-0.348-1.336-1.539-2.265-2.933-2.265l-6.766 0c-0.581 0-1.045 0.465-1.045 1.045s0.465 1.045 1.045 1.045l6.795 0c0.436 0 0.813 0.29 0.929 0.697l4.936 21.401c0 0.087 0 0.174 0.029 0.232l0.29 1.103 0 0.029c0 0 0 0 0 0.029l2.875 11.325c0.116 0.465 0.523 0.784 0.987 0.784l0.116 0 29.561 0c0.581 0 1.045-0.465 1.045-1.045s-0.465-1.045-1.016-1.045l0 0z"
            ></path>
          </g>
          <g className="a">
            <g className="a">
              <path
                className="st1"
                d="m86.732 57.444c1.887-2.207 4.995-3.485 7.84-3.601 2.207-0.087 4.443 0.436 6.359 1.481 0.697 0.377 1.684 1.045 2.12 1.51 0.29 0.29 1.074-0.058 0.755-0.377 -4.646-4.646-13.532-4.24-17.8 0.726 -0.319 0.377 0.465 0.552 0.726 0.261l0 0 0 0z"
              ></path>
            </g>
            <path
              className="st1"
              d="m89.142 48.326c0.145 0.61-0.203 1.22-0.726 1.394 -0.552 0.145-1.103-0.203-1.249-0.813 -0.145-0.61 0.203-1.22 0.726-1.394 0.552-0.174 1.103 0.203 1.249 0.813z"
            ></path>
            <path
              className="st1"
              d="m103.254 48.704c0.145 0.61-0.203 1.22-0.726 1.394 -0.552 0.145-1.103-0.203-1.249-0.813s0.203-1.22 0.726-1.394c0.552-0.174 1.132 0.203 1.249 0.813z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function IconChevronLeft({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill={fillColor} d="M10 16L20 6l1.4 1.4l-8.6 8.6l8.6 8.6L20 26z" />
    </svg>
  );
}
export function IconGift({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none" stroke={fillColor} strokeLinejoin="round">
        <path
          strokeLinecap="round"
          d="M4 11v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
        />
        <path d="M6 4.5A2.5 2.5 0 0 1 8.5 2A3.5 3.5 0 0 1 12 5.5V7H8.5A2.5 2.5 0 0 1 6 4.5zm12 0A2.5 2.5 0 0 0 15.5 2A3.5 3.5 0 0 0 12 5.5V7h3.5A2.5 2.5 0 0 0 18 4.5z" />
        <path strokeLinecap="round" d="M3 7h18v4H3zm9 4v10" />
      </g>
    </svg>
  );
}
export function IconGiftFill({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="none"
        d="M200 144h40v-40a40 40 0 1 0-40 40m152-40a40 40 0 0 0-80 0v40h40a40 40 0 0 0 40-40"
      />
      <path
        fill={fillColor}
        d="M80 416a64 64 0 0 0 64 64h92a4 4 0 0 0 4-4V292a4 4 0 0 0-4-4H88a8 8 0 0 0-8 8Zm160-164V144h32v108a4 4 0 0 0 4 4h140a47.9 47.9 0 0 0 16-2.75A48.09 48.09 0 0 0 464 208v-16a48 48 0 0 0-48-48h-40.54a2 2 0 0 1-1.7-3A72 72 0 0 0 256 58.82A72 72 0 0 0 138.24 141a2 2 0 0 1-1.7 3H96a48 48 0 0 0-48 48v16a48.09 48.09 0 0 0 32 45.25A47.9 47.9 0 0 0 96 256h140a4 4 0 0 0 4-4m32-148a40 40 0 1 1 40 40h-40Zm-74.86-39.9A40 40 0 0 1 240 104v40h-40a40 40 0 0 1-2.86-79.89ZM276 480h92a64 64 0 0 0 64-64V296a8 8 0 0 0-8-8H276a4 4 0 0 0-4 4v184a4 4 0 0 0 4 4"
      />
    </svg>
  );
}
export function IconUserCheck2({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <circle cx="24" cy="12" r="8" fill={fillColor} />
        <path d="M42 44c0-9.941-8.059-18-18-18S6 34.059 6 44" />
        <path d="m30 36l-8 8l-4-4" />
      </g>
    </svg>
  );
}
export function IconCalendar({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M17 14a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-4-5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-6-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M7 1.75a.75.75 0 0 1 .75.75v.763c.662-.013 1.391-.013 2.193-.013h4.113c.803 0 1.532 0 2.194.013V2.5a.75.75 0 0 1 1.5 0v.827c.26.02.506.045.739.076c1.172.158 2.121.49 2.87 1.238c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v2.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153H9.945c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-2.112c0-1.838 0-3.294.153-4.433c.158-1.172.49-2.121 1.238-2.87c.749-.748 1.698-1.08 2.87-1.238c.233-.031.48-.056.739-.076V2.5A.75.75 0 0 1 7 1.75M5.71 4.89c-1.005.135-1.585.389-2.008.812c-.423.423-.677 1.003-.812 2.009c-.023.17-.042.35-.058.539h18.336c-.016-.19-.035-.369-.058-.54c-.135-1.005-.389-1.585-.812-2.008c-.423-.423-1.003-.677-2.009-.812c-1.027-.138-2.382-.14-4.289-.14h-4c-1.907 0-3.261.002-4.29.14M2.75 12c0-.854 0-1.597.013-2.25h18.474c.013.653.013 1.396.013 2.25v2c0 1.907-.002 3.262-.14 4.29c-.135 1.005-.389 1.585-.812 2.008c-.423.423-1.003.677-2.009.812c-1.027.138-2.382.14-4.289.14h-4c-1.907 0-3.261-.002-4.29-.14c-1.005-.135-1.585-.389-2.008-.812c-.423-.423-.677-1.003-.812-2.009c-.138-1.027-.14-2.382-.14-4.289z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export function IconPaper({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none" stroke={fillColor}>
        <path d="M18 3a3 3 0 0 1 3 3v2.143c0 .334 0 .501-.077.623a.5.5 0 0 1-.157.157C20.644 9 20.477 9 20.143 9H15m3-6a3 3 0 0 0-3 3v3m3-6H7c-1.886 0-2.828 0-3.414.586C3 4.172 3 5.114 3 7v14l3-1l3 1l3-1l3 1V9" />
        <path strokeLinecap="round" d="M7 7h4m-3 4H7m0 4h3" />
      </g>
    </svg>
  );
}
export function IconTicket({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="m49.336 12.768l1.152 4.298a3.2 3.2 0 0 1-.967 3.22l-.155.13a5.001 5.001 0 0 0 2.218 8.87l.216.033a3.077 3.077 0 0 1 2.575 2.255l1.173 4.376a4 4 0 0 1-2.828 4.9L12.15 51.72a4 4 0 0 1-4.898-2.829l-1.103-4.117a3.485 3.485 0 0 1 .997-3.459l.163-.14a5.001 5.001 0 0 0-2.37-8.813a3.46 3.46 0 0 1-2.791-2.52L1.04 25.709a4 4 0 0 1 2.83-4.899L44.437 9.94a4 4 0 0 1 4.9 2.828m-4.165.607L4.951 24.152c-.555.149-.885.72-.736 1.275l.791 2.953a9.368 9.368 0 0 1 7.2 6.76a9.368 9.368 0 0 1-2.855 9.455l.791 2.953c.15.555.72.885 1.275.736l40.22-10.777c.555-.149.885-.72.736-1.275l-.79-2.952a9.369 9.369 0 0 1-7.2-6.761a9.368 9.368 0 0 1 2.854-9.455l-.791-2.953a1.041 1.041 0 0 0-1.275-.736m-1.283 21.559a3 3 0 1 1-5.796 1.552a3 3 0 0 1 5.796-1.552m-2.07-7.728a3 3 0 1 1-5.796 1.553a3 3 0 0 1 5.795-1.553m-2.071-7.727a3 3 0 1 1-5.796 1.553a3 3 0 0 1 5.796-1.553M29.383 6.347l2.552 3.644c.037.054.073.109.107.164L7.627 16.697L23.812 5.364a4 4 0 0 1 5.57.983"
      />
    </svg>
  );
}

export function IconCup({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M12 1.25c-1.828 0-3.339.161-4.502.357l-.134.023c-1.01.169-1.85.31-2.507 1.118c-.42.519-.557 1.08-.588 1.705l-.492.164c-.463.154-.87.29-1.191.44c-.348.162-.667.37-.911.709c-.244.338-.341.707-.385 1.088c-.04.353-.04.78-.04 1.269v.145c0 .402 0 .757.03 1.054c.032.321.103.634.28.936c.179.303.417.517.683.701c.245.17.555.343.907.538l2.64 1.467c.54 1.061 1.281 2.007 2.3 2.69c.887.596 1.952.97 3.213 1.069a.748.748 0 0 0-.053.277v1.75H9.82a1.75 1.75 0 0 0-1.716 1.407l-.219 1.093H6a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-1.885l-.219-1.093a1.75 1.75 0 0 0-1.716-1.407h-1.43V17a.748.748 0 0 0-.053-.277c1.261-.1 2.326-.473 3.213-1.068c1.02-.684 1.76-1.63 2.3-2.691l2.64-1.467c.352-.195.662-.368.907-.538c.265-.184.504-.398.682-.7c.178-.303.25-.616.281-.937c.03-.297.03-.652.03-1.054v-.145c0-.488 0-.916-.04-1.269c-.044-.381-.14-.75-.385-1.088c-.244-.339-.563-.547-.91-.71c-.323-.15-.729-.285-1.192-.439l-.492-.164c-.03-.626-.167-1.186-.588-1.705c-.656-.809-1.496-.95-2.506-1.118l-.135-.023A27.122 27.122 0 0 0 12 1.25m2.585 20l-.16-.799a.25.25 0 0 0-.245-.201H9.82a.25.25 0 0 0-.245.201l-.16.799zM4.288 6.028l.014-.005c.072 1.52.243 3.2.671 4.77l-1.066-.591c-.389-.217-.633-.353-.809-.475c-.162-.113-.215-.18-.244-.23c-.03-.05-.062-.128-.082-.324a10.58 10.58 0 0 1-.022-.938v-.073c0-.539.001-.88.03-1.138c.028-.238.072-.327.112-.381c.039-.055.109-.125.326-.226c.236-.11.56-.219 1.07-.39m15.41-.005c-.071 1.52-.243 3.2-.67 4.77l1.065-.591c.389-.217.633-.353.809-.475c.162-.113.215-.18.244-.23c.03-.05.062-.128.082-.324c.021-.214.022-.493.022-.938v-.073c0-.539-.001-.88-.03-1.138c-.028-.238-.072-.327-.112-.381c-.039-.055-.109-.125-.326-.226c-.236-.11-.56-.219-1.07-.39zM7.748 3.086A25.626 25.626 0 0 1 12 2.75c1.74 0 3.167.153 4.252.336c1.207.204 1.46.28 1.727.608c.262.322.287.628.233 1.983c-.09 2.258-.388 4.696-1.31 6.55c-.456.914-1.052 1.662-1.827 2.182c-.771.517-1.766.841-3.075.841c-1.309 0-2.303-.324-3.074-.841c-.776-.52-1.372-1.268-1.827-2.183c-.923-1.853-1.22-4.29-1.31-6.55c-.054-1.354-.03-1.66.233-1.982c.266-.328.519-.404 1.726-.608"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function IconEdit({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M19.09 14.441v4.44a2.37 2.37 0 0 1-2.369 2.369H5.12a2.37 2.37 0 0 1-2.369-2.383V7.279a2.356 2.356 0 0 1 2.37-2.37H9.56" />
        <path d="M6.835 15.803v-2.165c.002-.357.144-.7.395-.953l9.532-9.532a1.362 1.362 0 0 1 1.934 0l2.151 2.151a1.36 1.36 0 0 1 0 1.934l-9.532 9.532a1.361 1.361 0 0 1-.953.395H8.197a1.362 1.362 0 0 1-1.362-1.362M19.09 8.995l-4.085-4.086" />
      </g>
    </svg>
  );
}
export function IconClosePaper({ fillColor }) {
  return (
    <svg className="icon"
      width="800"
      height="540"
      viewBox="0 0 800 540"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M745.72 168.133H573.539L448.912 43.5078C445.864 19.2235 425.098 0.368774 399.998 0.368774C374.898 0.368774 354.134 19.2219 351.086 43.5078L226.459 168.133H54.2797C24.35 168.133 0 192.483 0 222.413V485.35C0 515.281 24.35 539.63 54.2797 539.63H745.722C775.653 539.63 800.002 515.28 800.002 485.35V222.413C800 192.483 775.65 168.133 745.72 168.133ZM399.998 28.2547C411.816 28.2547 421.428 37.8672 421.428 49.6844C421.428 61.5 411.816 71.1141 399.998 71.1141C388.183 71.1141 378.569 61.5016 378.569 49.6844C378.569 37.8672 388.184 28.2547 399.998 28.2547ZM358.211 75.8188C366.941 89.725 382.403 98.9985 400 98.9985C417.597 98.9985 433.061 89.7282 441.791 75.8188L534.106 168.133H265.894L358.211 75.8188ZM772.116 485.35C772.116 499.905 760.275 511.745 745.72 511.745H54.2797C39.725 511.745 27.8844 499.905 27.8844 485.35V222.413C27.8844 207.858 39.725 196.017 54.2797 196.017H745.722C760.277 196.017 772.117 207.858 772.117 222.413V485.35H772.116Z"
        fill={fillColor}
      />
      <path
        d="M108.478 402.861C106.052 402.861 103.548 402.717 100.965 402.43C98.4087 402.17 95.9304 401.661 93.5304 400.904C91.1565 400.148 88.9391 399.078 86.8783 397.696C84.8174 396.339 83.0826 394.565 81.6739 392.374C80.3435 390.261 79.313 387.939 78.5826 385.409C77.8522 382.878 77.487 380.048 77.487 376.917C77.487 374.622 77.5783 372.443 77.7609 370.383C77.9696 368.296 78.2826 366.235 78.7 364.2C79.1174 362.165 79.6522 360.104 80.3043 358.017C80.9826 355.93 81.7913 353.713 82.7304 351.365L92.787 355.552C92.0304 357.43 91.3783 359.126 90.8304 360.639C90.3087 362.152 89.8652 363.535 89.5 364.787C89.1348 366.013 88.8478 367.148 88.6391 368.191C88.4304 369.235 88.2739 370.239 88.1696 371.204C88.0652 372.143 88 373.083 87.9739 374.022C87.9478 374.935 87.9348 375.9 87.9348 376.917C87.9348 378.874 88.2478 380.57 88.8739 382.004C89.5 383.439 90.3478 384.652 91.4174 385.643C92.487 386.635 93.713 387.443 95.0957 388.07C96.5043 388.722 97.9652 389.217 99.4783 389.557C100.991 389.896 102.517 390.13 104.057 390.261C105.622 390.391 107.096 390.457 108.478 390.457C109.157 390.457 110.161 390.404 111.491 390.3C112.822 390.222 114.27 390.065 115.835 389.83C117.426 389.622 119.043 389.335 120.687 388.97C122.357 388.604 123.87 388.148 125.226 387.6C126.583 387.078 127.691 386.452 128.552 385.722C129.413 385.017 129.843 384.183 129.843 383.217C129.843 383.113 129.622 382.93 129.178 382.67C128.761 382.409 128.174 382.096 127.417 381.73C126.687 381.391 125.826 381 124.835 380.557C123.87 380.139 122.826 379.709 121.704 379.265H121.743C120.491 378.874 119.174 378.535 117.791 378.248C116.435 377.987 115.091 377.752 113.761 377.543C113.552 377.517 113.278 377.478 112.939 377.426C112.626 377.374 112.3 377.309 111.961 377.23C111.622 377.178 111.283 377.113 110.943 377.035C110.63 376.983 110.37 376.93 110.161 376.878L111.765 364.983H143.148C143.983 364.983 144.778 365.139 145.535 365.452C146.291 365.765 146.943 366.209 147.491 366.783C148.065 367.33 148.522 367.983 148.861 368.739C149.2 369.496 149.37 370.304 149.37 371.165C149.37 372.026 149.2 372.835 148.861 373.591C148.522 374.348 148.065 375 147.491 375.548C146.943 376.122 146.291 376.565 145.535 376.878C144.778 377.191 143.983 377.348 143.148 377.348H138.804C139.352 378.391 139.743 379.435 139.978 380.478C140.239 381.548 140.383 382.461 140.409 383.217C140.278 385.67 139.652 387.848 138.53 389.752C137.435 391.683 136.013 393.378 134.265 394.839C132.517 396.3 130.535 397.539 128.317 398.557C126.1 399.574 123.83 400.396 121.509 401.022C119.187 401.674 116.891 402.143 114.622 402.43C112.378 402.717 110.33 402.861 108.478 402.861ZM137.19 371.126C137.19 370.265 137.359 369.47 137.698 368.739C138.011 367.983 138.442 367.33 138.99 366.783C139.538 366.209 140.19 365.765 140.946 365.452C141.703 365.139 142.511 364.983 143.372 364.983H143.725C144.116 364.983 144.481 364.983 144.82 364.983C145.185 364.983 145.59 364.97 146.033 364.943C146.503 364.917 147.051 364.891 147.677 364.865C148.329 364.839 149.138 364.8 150.103 364.748C149.19 363.183 148.498 361.526 148.029 359.778C147.559 358.004 147.325 356.217 147.325 354.417C147.325 353.061 147.455 351.704 147.716 350.348C147.977 348.991 148.368 347.7 148.89 346.474C149.411 345.222 150.064 344.048 150.846 342.952C151.629 341.83 152.555 340.813 153.625 339.9L151.59 338.765L159.142 327.652C160.264 328.435 161.607 329.23 163.172 330.039C164.738 330.848 166.381 331.657 168.103 332.465C169.825 333.248 171.546 334.017 173.268 334.774C175.016 335.504 176.62 336.196 178.081 336.848C180.559 337.996 182.751 339.013 184.655 339.9C186.585 340.761 188.32 341.622 189.859 342.483C191.398 343.317 192.781 344.204 194.007 345.143C195.233 346.083 196.381 347.178 197.451 348.43C198.807 350.152 199.785 352.03 200.385 354.065C200.985 356.1 201.285 358.07 201.285 359.974C201.285 362.896 200.529 365.661 199.016 368.27C197.529 370.852 195.325 373.017 192.403 374.765C191.594 375.235 190.59 375.639 189.39 375.978C188.216 376.317 186.977 376.591 185.672 376.8C184.394 377.035 183.129 377.204 181.877 377.309C180.625 377.413 179.529 377.465 178.59 377.465C177.494 377.465 176.307 377.413 175.029 377.309C173.751 377.23 172.459 377.087 171.155 376.878C169.877 376.696 168.625 376.448 167.398 376.135C166.172 375.822 165.051 375.457 164.033 375.039C162.781 375.404 161.333 375.73 159.69 376.017C158.072 376.304 156.364 376.539 154.564 376.722C152.764 376.93 150.938 377.087 149.085 377.191C147.233 377.296 145.446 377.348 143.725 377.348H143.372C142.511 377.348 141.703 377.178 140.946 376.839C140.19 376.526 139.538 376.083 138.99 375.509C138.442 374.961 138.011 374.309 137.698 373.552C137.359 372.796 137.19 371.987 137.19 371.126ZM165.638 345.809C164.803 345.678 163.903 345.926 162.938 346.552C161.998 347.178 161.138 347.987 160.355 348.978C159.572 349.97 158.946 351.065 158.477 352.265C158.007 353.439 157.825 354.535 157.929 355.552V355.513C158.007 356.191 158.268 356.896 158.711 357.626C159.155 358.33 159.677 359.022 160.277 359.7C160.903 360.352 161.568 360.939 162.272 361.461C162.977 361.957 163.629 362.322 164.229 362.557C165.22 362.452 166.185 362.217 167.125 361.852C168.09 361.487 168.951 360.939 169.707 360.209C170.464 359.478 171.077 358.539 171.546 357.391C172.016 356.243 172.251 354.835 172.251 353.165C172.251 352.304 172.003 351.457 171.507 350.622C171.038 349.787 170.464 349.03 169.785 348.352C169.107 347.648 168.377 347.074 167.594 346.63C166.838 346.161 166.185 345.887 165.638 345.809ZM182.542 352.304C182.542 353.4 182.411 354.548 182.151 355.748C181.89 356.948 181.538 358.135 181.094 359.309C180.651 360.483 180.142 361.63 179.568 362.752C179.02 363.848 178.433 364.865 177.807 365.804H178.159C180.064 365.804 181.811 365.739 183.403 365.609C185.02 365.452 186.416 365.165 187.59 364.748C188.764 364.304 189.69 363.704 190.368 362.948C191.072 362.165 191.49 361.135 191.62 359.857C191.672 359.23 191.411 358.552 190.838 357.822C190.264 357.065 189.52 356.322 188.607 355.591C187.72 354.835 186.729 354.104 185.633 353.4C184.538 352.696 183.507 352.07 182.542 351.522V352.304ZM209.409 359.074C210.505 359.778 211.783 360.483 213.244 361.187C214.731 361.891 216.244 362.543 217.783 363.143C219.348 363.717 220.861 364.187 222.322 364.552C223.783 364.917 225.048 365.1 226.118 365.1C226.509 365.1 227.018 365.087 227.644 365.061C228.27 365.009 228.922 364.93 229.6 364.826C230.305 364.696 231.009 364.539 231.713 364.357C232.418 364.148 233.057 363.887 233.631 363.574C234.231 363.261 234.713 362.896 235.079 362.478C235.444 362.035 235.64 361.513 235.666 360.913C235.692 359.896 235.379 358.748 234.726 357.47C234.1 356.191 233.24 354.861 232.144 353.478C231.074 352.07 229.822 350.661 228.387 349.252C226.979 347.817 225.518 346.448 224.005 345.143C222.492 343.813 220.979 342.587 219.466 341.465C217.953 340.317 216.557 339.339 215.279 338.53L222.205 328.239C224.735 330.013 227.24 331.996 229.718 334.187C232.222 336.378 234.531 338.713 236.644 341.191C238.757 343.643 240.583 346.187 242.122 348.822C243.661 351.457 244.77 354.091 245.448 356.726C245.657 357.483 245.8 358.252 245.879 359.035C245.957 359.791 245.996 360.522 245.996 361.226C245.996 363.652 245.526 365.883 244.587 367.917C243.648 369.926 242.331 371.674 240.635 373.161C238.966 374.622 236.957 375.757 234.609 376.565C232.261 377.374 229.679 377.778 226.861 377.778C226.653 377.778 226.444 377.765 226.235 377.739C226.026 377.739 225.818 377.739 225.609 377.739C223.809 377.739 221.957 377.543 220.053 377.152C218.174 376.787 216.309 376.291 214.457 375.665C212.631 375.039 210.844 374.309 209.096 373.474C207.374 372.639 205.77 371.765 204.283 370.852L209.409 359.074ZM356.103 377.27C353.859 377.27 351.968 376.839 350.429 375.978C348.916 375.117 347.663 374.035 346.672 372.73C346.124 373.435 345.537 374.074 344.911 374.648C344.285 375.196 343.542 375.665 342.681 376.057C341.846 376.474 340.855 376.787 339.707 376.996C338.585 377.204 337.242 377.309 335.676 377.309C334.581 377.309 333.576 377.23 332.663 377.074C331.75 376.917 330.916 376.722 330.159 376.487C330.133 379.539 329.663 382.317 328.75 384.822C327.863 387.326 326.637 389.57 325.072 391.552C323.533 393.535 321.72 395.257 319.633 396.717C317.546 398.178 315.303 399.378 312.903 400.317C310.503 401.283 307.985 402 305.35 402.47C302.742 402.939 300.146 403.174 297.563 403.174C293.572 403.174 289.881 402.509 286.489 401.178C283.098 399.874 280.163 398.022 277.685 395.622C275.233 393.248 273.316 390.378 271.933 387.013C270.55 383.674 269.859 379.983 269.859 375.939C269.937 373.591 270.25 371.191 270.798 368.739C271.372 366.287 272.089 363.887 272.95 361.539C273.837 359.191 274.816 356.961 275.885 354.848C276.981 352.709 278.089 350.791 279.211 349.096L287.742 355.63C286.803 357.17 285.903 358.8 285.042 360.522C284.181 362.243 283.424 363.991 282.772 365.765C282.146 367.513 281.637 369.274 281.246 371.048C280.855 372.822 280.659 374.53 280.659 376.174C280.581 378.157 280.959 380.022 281.794 381.77C282.655 383.543 283.842 385.083 285.355 386.387C286.894 387.717 288.694 388.761 290.755 389.517C292.816 390.3 295.033 390.691 297.407 390.691C299.207 390.691 300.994 390.561 302.768 390.3C304.568 390.065 306.276 389.661 307.894 389.087C309.537 388.539 311.063 387.822 312.472 386.935C313.881 386.074 315.094 385.017 316.111 383.765C317.155 382.513 317.963 381.052 318.537 379.383C319.137 377.739 319.437 375.861 319.437 373.748C319.437 372.183 319.203 370.552 318.733 368.857C318.263 367.135 317.637 365.387 316.855 363.613C316.098 361.813 315.224 359.987 314.233 358.135C313.268 356.283 312.263 354.43 311.22 352.578L322.059 346.787C322.998 349.03 323.976 351.235 324.994 353.4C326.011 355.565 327.068 357.509 328.163 359.23C329.259 360.926 330.394 362.296 331.568 363.339C332.742 364.357 333.955 364.839 335.207 364.787C336.25 364.761 337.072 364.474 337.672 363.926C338.298 363.378 338.781 362.661 339.12 361.774C339.459 360.887 339.681 359.87 339.785 358.722C339.889 357.574 339.942 356.374 339.942 355.122C339.916 354.026 339.876 352.904 339.824 351.757C339.772 350.583 339.733 349.448 339.707 348.352L350.82 346.826C350.82 347.557 350.846 348.522 350.898 349.722C350.976 350.896 351.094 352.161 351.25 353.517C351.433 354.874 351.668 356.243 351.955 357.626C352.268 359.009 352.659 360.261 353.129 361.383C353.598 362.478 354.159 363.378 354.811 364.083C355.463 364.787 356.233 365.139 357.12 365.139C357.981 365.139 358.737 364.748 359.389 363.965C360.068 363.157 360.629 362.126 361.072 360.874C361.542 359.622 361.881 358.239 362.089 356.726C362.324 355.187 362.442 353.687 362.442 352.226C362.442 351.652 362.429 351.248 362.403 351.013C362.403 350.752 362.403 350.53 362.403 350.348C362.403 350.139 362.389 349.904 362.363 349.643C362.363 349.357 362.363 348.9 362.363 348.274L372.968 346.748L373.242 349.839V349.8C373.294 350.478 373.346 351.104 373.398 351.678C373.476 352.252 373.555 352.852 373.633 353.478C373.711 354.078 373.803 354.73 373.907 355.435C374.011 356.139 374.129 356.961 374.259 357.9C374.416 359.1 374.755 360.143 375.276 361.03C375.798 361.917 376.411 362.661 377.116 363.261C377.82 363.835 378.563 364.265 379.346 364.552C380.129 364.839 380.872 364.983 381.576 364.983H382.046C383.011 364.983 383.885 365.152 384.668 365.491C385.476 365.804 386.168 366.248 386.742 366.822C387.316 367.37 387.759 368.022 388.072 368.778C388.385 369.535 388.542 370.343 388.542 371.204C388.542 372.065 388.385 372.874 388.072 373.63C387.759 374.387 387.316 375.039 386.742 375.587C386.168 376.135 385.476 376.565 384.668 376.878C383.859 377.217 382.959 377.387 381.968 377.387C379.046 377.387 376.476 376.917 374.259 375.978C372.042 375.065 370.15 373.591 368.585 371.557C367.176 373.357 365.416 374.752 363.303 375.743C361.189 376.761 358.789 377.27 356.103 377.27ZM411.647 390.222L404.134 397.774L396.699 390.339L389.343 397.696L381.752 390.143L389.265 382.591L396.699 390.026L404.056 382.67L411.647 390.222ZM373.808 371.165C373.808 370.304 373.978 369.496 374.317 368.739C374.63 367.983 375.06 367.33 375.608 366.783C376.156 366.209 376.808 365.765 377.565 365.452C378.321 365.139 379.13 364.983 379.991 364.983H384.334H386.212C387.386 364.983 388.678 364.93 390.086 364.826C391.495 364.722 392.852 364.552 394.156 364.317C395.46 364.083 396.634 363.77 397.678 363.378C398.747 362.961 399.53 362.439 400.026 361.813C400.312 361.37 400.456 360.77 400.456 360.013C400.456 358.891 400.182 357.561 399.634 356.022C399.112 354.483 398.486 352.917 397.756 351.326C397.026 349.735 396.269 348.209 395.486 346.748C394.73 345.287 394.117 344.074 393.647 343.109L404.799 337.63C405.608 339.039 406.391 340.709 407.147 342.639C407.904 344.543 408.582 346.513 409.182 348.548C409.782 350.557 410.265 352.539 410.63 354.496C410.995 356.426 411.178 358.109 411.178 359.543C411.178 362.178 410.708 364.591 409.769 366.783C408.673 369.235 407.173 371.27 405.269 372.887C403.365 374.478 401.082 375.652 398.421 376.409C397.639 376.617 396.66 376.787 395.486 376.917C394.312 377.048 393.126 377.139 391.926 377.191C390.726 377.27 389.591 377.309 388.521 377.309C387.452 377.335 386.617 377.348 386.017 377.348H380.343H379.991C379.13 377.348 378.321 377.191 377.565 376.878C376.808 376.565 376.156 376.122 375.608 375.548C375.06 375 374.63 374.348 374.317 373.591C373.978 372.835 373.808 372.026 373.808 371.165ZM433.506 351.913C432.958 351.809 432.332 352.004 431.628 352.5C430.949 352.97 430.297 353.622 429.671 354.457C429.071 355.265 428.562 356.165 428.145 357.157C427.754 358.148 427.558 359.1 427.558 360.013C427.558 360.874 427.806 361.591 428.302 362.165C428.797 362.739 429.423 363.209 430.18 363.574C430.962 363.939 431.81 364.213 432.723 364.396C433.662 364.578 434.562 364.709 435.423 364.787H435.384C436.062 364.839 436.832 364.878 437.693 364.904C438.58 364.904 439.441 364.904 440.275 364.904C440.536 364.904 440.732 364.917 440.862 364.943C441.019 364.943 441.149 364.943 441.254 364.943C441.358 364.943 441.462 364.943 441.567 364.943C441.697 364.943 441.88 364.93 442.115 364.904C441.723 363.287 441.254 361.748 440.706 360.287C440.184 358.8 439.571 357.47 438.867 356.296C438.162 355.122 437.367 354.157 436.48 353.4C435.593 352.617 434.602 352.122 433.506 351.913ZM414.332 392.883C418.01 392.152 421.362 391.226 424.389 390.104C427.415 389.009 430.062 387.77 432.332 386.387C434.628 385.03 436.519 383.583 438.006 382.043C439.519 380.504 440.589 378.939 441.215 377.348C440.093 377.348 438.906 377.322 437.654 377.27C436.402 377.243 435.371 377.204 434.562 377.152C431.536 376.891 428.771 376.213 426.267 375.117C423.762 374.048 421.767 372.587 420.28 370.735C419.184 369.326 418.402 367.8 417.932 366.157C417.489 364.513 417.267 362.778 417.267 360.952C417.267 359.543 417.397 358.135 417.658 356.726C417.919 355.291 418.284 353.909 418.754 352.578C419.223 351.222 419.771 349.943 420.397 348.743C421.049 347.543 421.741 346.448 422.471 345.457C424.036 343.5 425.745 342.026 427.597 341.035C429.475 340.017 431.445 339.509 433.506 339.509C437.915 339.509 441.893 341.439 445.441 345.3C446.693 346.709 447.815 348.287 448.806 350.035C449.797 351.783 450.632 353.648 451.31 355.63C452.015 357.587 452.549 359.648 452.915 361.813C453.28 363.952 453.462 366.13 453.462 368.348C453.462 369.026 453.436 369.704 453.384 370.383C453.358 371.061 453.319 371.7 453.267 372.3C452.954 375.352 452.262 378.209 451.193 380.87C450.149 383.557 448.793 386.022 447.123 388.265C445.48 390.535 443.562 392.583 441.371 394.409C439.18 396.261 436.793 397.878 434.21 399.261C431.654 400.67 428.941 401.843 426.071 402.783C423.202 403.722 420.254 404.426 417.228 404.896L414.332 392.883ZM486.613 377.348C486.039 377.348 485.23 377.309 484.187 377.23C483.143 377.152 482.021 376.865 480.821 376.37C480.247 379.604 479.165 382.67 477.573 385.565C476.008 388.487 474.065 391.213 471.743 393.743C469.421 396.3 466.773 398.648 463.8 400.787C460.826 402.926 457.656 404.843 454.291 406.539L447.13 396.639C448.982 395.7 450.847 394.67 452.726 393.548C454.604 392.452 456.391 391.278 458.087 390.026C459.808 388.8 461.4 387.509 462.86 386.152C464.347 384.822 465.639 383.439 466.734 382.004C467.83 380.57 468.691 379.096 469.317 377.583C469.943 376.096 470.256 374.583 470.256 373.043C470.256 372.965 470.243 372.848 470.217 372.691C470.217 372.535 470.217 372.378 470.217 372.222C470.217 372.065 470.204 371.948 470.178 371.87C470.178 371.791 470.178 371.804 470.178 371.909V371.948C469.995 370.435 469.734 368.987 469.395 367.604C469.056 366.222 468.626 364.813 468.104 363.378C467.608 361.943 467.021 360.443 466.343 358.878C465.665 357.287 464.908 355.552 464.073 353.674L475.382 348.743C476.426 351.874 477.404 354.483 478.317 356.57C479.23 358.657 480.117 360.326 480.978 361.578C481.865 362.83 482.752 363.717 483.639 364.239C484.526 364.735 485.465 364.983 486.456 364.983H486.652C487.513 364.983 488.321 365.152 489.078 365.491C489.834 365.83 490.487 366.287 491.034 366.861C491.608 367.409 492.052 368.061 492.365 368.817C492.704 369.574 492.873 370.37 492.873 371.204C492.873 372.065 492.704 372.874 492.365 373.63C492.052 374.387 491.608 375.039 491.034 375.587C490.487 376.135 489.834 376.565 489.078 376.878C488.321 377.191 487.5 377.348 486.613 377.348ZM480.326 371.204C480.326 370.396 480.482 369.626 480.795 368.896C481.108 368.165 481.526 367.526 482.047 366.978C482.569 366.404 483.195 365.948 483.926 365.609C484.63 365.243 485.386 365.035 486.195 364.983C488.152 364.983 489.795 364.461 491.126 363.417C492.482 362.348 493.643 360.952 494.608 359.23C495.573 357.509 496.395 355.552 497.073 353.361C497.752 351.143 498.391 348.887 498.991 346.591L509.4 348.47C509.191 349.383 508.93 350.452 508.617 351.678C508.33 352.878 508.056 354.13 507.795 355.435C507.56 356.739 507.365 358.017 507.208 359.27C507.052 360.496 507.013 361.578 507.091 362.517C507.195 363.457 507.443 364.2 507.834 364.748C508.226 365.27 508.826 365.465 509.634 365.335C510.678 365.257 511.617 364.891 512.452 364.239C513.313 363.587 514.082 362.752 514.76 361.735C515.439 360.717 516.039 359.57 516.56 358.291C517.082 357.013 517.526 355.696 517.891 354.339C518.282 352.983 518.595 351.639 518.83 350.309C519.091 348.978 519.3 347.765 519.456 346.67L529.395 348.352C529.369 349.135 529.278 350.1 529.121 351.248C528.965 352.396 528.821 353.609 528.691 354.887C528.56 356.139 528.495 357.404 528.495 358.683C528.495 359.935 528.639 361.07 528.926 362.087C529.213 363.078 529.682 363.887 530.334 364.513C531.013 365.139 531.952 365.452 533.152 365.452C533.882 365.452 534.626 365.335 535.382 365.1C536.139 364.839 536.817 364.487 537.417 364.043C538.017 363.574 538.5 363.026 538.865 362.4C539.256 361.774 539.452 361.07 539.452 360.287C539.452 358.93 539.23 357.443 538.786 355.826C538.343 354.183 537.808 352.565 537.182 350.974C536.556 349.357 535.891 347.83 535.186 346.396C534.508 344.961 533.934 343.748 533.465 342.757L543.169 337.317C543.326 337.657 543.6 338.257 543.991 339.117C544.382 339.952 544.826 340.97 545.321 342.17C545.817 343.37 546.326 344.726 546.847 346.239C547.395 347.726 547.891 349.278 548.334 350.896C548.778 352.513 549.143 354.17 549.43 355.865C549.717 357.561 549.86 359.204 549.86 360.796C549.86 363.404 549.495 365.752 548.765 367.839C548.06 369.926 546.978 371.7 545.517 373.161C544.082 374.622 542.269 375.757 540.078 376.565C537.913 377.374 535.369 377.791 532.447 377.817C531.039 377.817 529.76 377.674 528.613 377.387C527.465 377.126 526.434 376.748 525.521 376.252C524.608 375.783 523.786 375.222 523.056 374.57C522.352 373.917 521.726 373.226 521.178 372.496C520.552 373.304 519.873 374.035 519.143 374.687C518.439 375.313 517.617 375.848 516.678 376.291C515.765 376.761 514.734 377.126 513.586 377.387C512.439 377.648 511.134 377.791 509.673 377.817C508.395 377.843 507.234 377.726 506.191 377.465C505.173 377.23 504.234 376.878 503.373 376.409C502.513 375.939 501.73 375.378 501.026 374.726C500.347 374.048 499.708 373.304 499.108 372.496C498.56 373.174 497.934 373.813 497.23 374.413C496.526 374.987 495.691 375.496 494.726 375.939C493.76 376.383 492.639 376.735 491.36 376.996C490.082 377.257 488.595 377.387 486.9 377.387H486.195C485.386 377.335 484.63 377.139 483.926 376.8C483.195 376.461 482.569 376.017 482.047 375.47C481.526 374.922 481.108 374.283 480.795 373.552C480.482 372.822 480.326 372.039 480.326 371.204ZM574.677 405.952L573.151 367.409C573.151 367.2 573.177 366.743 573.229 366.039C573.281 365.335 573.425 364.526 573.66 363.613C573.921 362.674 574.325 361.696 574.873 360.678C575.447 359.661 576.242 358.748 577.26 357.939C577.912 357.365 578.812 356.896 579.96 356.53C581.134 356.165 582.307 355.983 583.481 355.983C583.69 355.983 583.899 355.996 584.107 356.022C584.316 356.022 584.525 356.035 584.734 356.061C585.125 354.991 585.594 353.909 586.142 352.813C586.69 351.691 587.277 350.622 587.903 349.604C588.529 348.561 589.194 347.583 589.899 346.67C590.603 345.73 591.307 344.909 592.012 344.204C593.603 342.613 595.247 341.465 596.942 340.761C598.638 340.03 600.438 339.691 602.342 339.743C604.873 339.848 607.116 340.396 609.073 341.387C611.055 342.378 612.79 343.852 614.277 345.809C616.521 348.887 617.786 352.578 618.073 356.883C618.099 357.17 618.112 357.483 618.112 357.822C618.112 358.161 618.112 358.474 618.112 358.761C618.112 360.404 617.968 361.996 617.681 363.535C617.421 365.074 616.99 366.548 616.39 367.957L616.429 367.917C615.516 370.265 614.316 372.13 612.829 373.513C611.342 374.896 609.621 375.757 607.664 376.096L607.781 376.017C607.521 376.096 607.26 376.161 606.999 376.213C606.738 376.265 606.464 376.291 606.177 376.291C605.316 376.291 604.26 376.109 603.007 375.743C601.781 375.378 600.451 374.922 599.016 374.374C597.581 373.8 596.107 373.2 594.594 372.574C593.081 371.922 591.634 371.322 590.251 370.774C589.494 370.487 588.855 370.239 588.334 370.03C587.812 369.796 587.329 369.6 586.886 369.443C586.468 369.261 586.051 369.104 585.634 368.974C585.242 368.817 584.799 368.661 584.303 368.504C584.642 374.478 585.034 380.387 585.477 386.23C585.921 392.1 586.312 397.996 586.651 403.917L574.677 405.952ZM596.081 356.413C595.794 356.961 595.547 357.457 595.338 357.9C595.155 358.317 594.986 358.709 594.829 359.074C595.638 359.413 596.551 359.804 597.568 360.248C598.586 360.665 599.629 361.096 600.699 361.539C601.794 361.983 602.851 362.4 603.868 362.791C604.912 363.183 605.838 363.496 606.647 363.73C606.881 363.078 607.064 362.296 607.194 361.383C607.351 360.47 607.429 359.687 607.429 359.035C607.429 358.043 607.273 357.117 606.96 356.257C606.647 355.396 606.229 354.652 605.707 354.026C605.212 353.4 604.638 352.917 603.986 352.578C603.334 352.239 602.681 352.096 602.029 352.148C601.742 352.174 601.351 352.252 600.855 352.383C600.36 352.513 599.825 352.735 599.251 353.048C598.703 353.361 598.142 353.791 597.568 354.339C596.994 354.887 596.499 355.578 596.081 356.413ZM639.972 377.348C636.554 377.348 633.202 376.696 629.915 375.391C626.654 374.087 623.628 371.987 620.837 369.091L627.92 359.113C629.198 360.287 630.437 361.252 631.637 362.009C632.837 362.739 633.985 363.313 635.081 363.73C636.176 364.148 637.207 364.435 638.172 364.591C639.163 364.748 640.089 364.826 640.95 364.826C641.341 364.826 641.785 364.813 642.281 364.787C642.776 364.761 643.272 364.722 643.767 364.67C644.263 364.591 644.746 364.5 645.215 364.396C645.685 364.291 646.115 364.161 646.507 364.004C647.863 363.43 648.933 362.857 649.715 362.283C648.724 359.883 647.641 357.391 646.467 354.809C645.32 352.2 644.159 349.591 642.985 346.983C641.811 344.348 640.65 341.739 639.502 339.157C638.354 336.574 637.285 334.096 636.294 331.722L647.72 326.948L651.202 335.4C652.324 338.165 653.667 341.452 655.233 345.261C656.798 349.043 658.598 353.335 660.633 358.135C661.102 359.283 661.533 360.287 661.924 361.148C662.315 362.009 662.772 362.726 663.294 363.3C663.841 363.874 664.481 364.304 665.211 364.591C665.967 364.852 666.933 364.983 668.107 364.983C668.941 364.983 669.737 365.139 670.494 365.452C671.25 365.765 671.902 366.209 672.45 366.783C673.024 367.33 673.481 367.983 673.82 368.739C674.159 369.496 674.328 370.304 674.328 371.165C674.328 372.026 674.159 372.835 673.82 373.591C673.481 374.348 673.024 375 672.45 375.548C671.902 376.122 671.25 376.565 670.494 376.878C669.737 377.191 668.941 377.348 668.107 377.348C666.515 377.348 665.107 377.243 663.881 377.035C662.681 376.826 661.598 376.526 660.633 376.135C659.694 375.77 658.846 375.326 658.089 374.804C657.359 374.257 656.667 373.657 656.015 373.004C655.311 373.474 654.567 373.93 653.785 374.374C653.002 374.791 652.102 375.209 651.085 375.626C649.52 376.226 647.824 376.657 645.998 376.917C644.198 377.204 642.189 377.348 639.972 377.348ZM704.08 351.483C703.402 351.117 702.71 350.791 702.006 350.504C701.328 350.191 700.623 349.904 699.893 349.643C698.641 349.2 697.245 348.835 695.706 348.548C694.167 348.261 692.576 348.209 690.932 348.391C689.81 348.522 688.728 348.822 687.684 349.291C686.667 349.761 685.754 350.348 684.945 351.052C684.163 351.73 683.537 352.5 683.067 353.361C682.597 354.222 682.363 355.096 682.363 355.983C682.363 357.235 682.754 358.343 683.537 359.309C684.319 360.248 685.31 361.03 686.51 361.657C687.737 362.283 689.08 362.752 690.541 363.065C692.002 363.378 693.423 363.509 694.806 363.457C696.293 363.326 697.832 363.143 699.423 362.909C701.041 362.674 702.554 362.426 703.963 362.165C704.771 362.035 705.58 361.891 706.389 361.735C707.197 361.578 708.006 361.409 708.815 361.226L710.419 373.396C708.671 373.865 706.715 374.335 704.55 374.804C702.384 375.248 699.932 375.652 697.193 376.017C694.454 376.409 691.389 376.709 687.997 376.917C684.606 377.152 680.823 377.27 676.65 377.27L668.119 377.348C667.258 377.348 666.45 377.178 665.693 376.839C664.91 376.526 664.245 376.083 663.697 375.509C663.123 374.961 662.68 374.309 662.367 373.552C662.028 372.796 661.858 371.987 661.858 371.126C661.858 370.265 662.028 369.47 662.367 368.739C662.706 368.009 663.163 367.37 663.737 366.822C664.31 366.274 664.976 365.843 665.732 365.53C666.463 365.191 667.245 364.996 668.08 364.943L674.184 364.865C673.245 363.378 672.593 361.865 672.228 360.326C671.863 358.787 671.693 357.104 671.719 355.278C671.745 352.983 672.254 350.726 673.245 348.509C674.263 346.291 675.632 344.296 677.354 342.522C679.102 340.748 681.137 339.274 683.458 338.1C685.78 336.926 688.271 336.235 690.932 336.026C692.263 335.922 693.541 335.935 694.767 336.065C695.993 336.17 697.154 336.365 698.25 336.652C699.345 336.913 700.376 337.239 701.341 337.63C702.306 337.996 703.18 338.387 703.963 338.804C704.876 339.3 705.75 339.835 706.584 340.409C707.419 340.957 708.202 341.557 708.932 342.209L704.08 351.483Z"
        fill={fillColor}
      />
    </svg>
  );
}
export function IconInfo({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <circle
        cx="17.93"
        cy="11.9"
        r="1.4"
        fill={fillColor}
        className="clr-i-outline clr-i-outline-path-1"
      />
      <path
        fill={fillColor}
        d="M21 23h-2v-8h-3a1 1 0 0 0 0 2h1v6h-2a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2"
        className="clr-i-outline clr-i-outline-path-2"
      />
      <path
        fill={fillColor}
        d="M18 6a12 12 0 1 0 12 12A12 12 0 0 0 18 6m0 22a10 10 0 1 1 10-10a10 10 0 0 1-10 10"
        className="clr-i-outline clr-i-outline-path-3"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
}

export function IconIranFlag({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 513 357.071"
    >
      <g fillRule="nonzero">
        <path
          fill="#DA0000"
          d="M28.477.32h456.044c15.488 0 28.159 12.672 28.159 28.16v300.111c0 15.488-12.671 28.16-28.159 28.16H28.477c-15.486 0-28.157-12.672-28.157-28.16V28.48C.32 12.992 12.991.32 28.477.32z"
        />
        <path
          fill="#fff"
          d="M.32 237.942h512.36V28.48c0-15.488-12.671-28.16-28.159-28.16H28.477C12.991.32.32 12.992.32 28.48v209.462z"
        />
        <path
          fill="#239F40"
          d="M.32 119.129h512.36V28.48c0-15.488-12.671-28.16-28.159-28.16H28.477C12.991.32.32 12.992.32 28.48v90.649z"
        />
        <path
          fill="#fff"
          d="M512.68 99.723v2.772h-3.228v-2.772h3.228zm0 5.545v2.772h-.455v5.545h-2.773v-8.317h3.228zm0 11.089v5.545h-3.228v-5.545h3.228zM.32 121.902v-5.545h5.288v5.545H.32zm0-8.317v-2.773h2.516V99.723h2.772v13.862H.32zm453.481 2.772h24.951v5.545h-24.951v-5.545zm27.722 0h24.952v5.545h-24.952v-5.545zm-27.722-16.634h36.04v2.772h-36.04v-2.772zm-.001 13.862v-8.317h13.863v5.544h8.315v-2.772h-5.543v-2.772h8.317v8.317h-13.863v-5.545h-8.315v5.545H453.8zm5.546-2.773h2.771v2.773h-2.771v-2.773zm30.495 2.773h-8.319v-8.317h11.091v-5.545h2.772v11.089h2.772V99.723h2.774v11.089h2.77V99.723h2.774v13.862h-13.862v-5.545h-8.317v2.772h5.545v2.773zm-91.692 2.772h24.95v5.545h-24.95v-5.545zm27.722 0h24.951v5.545h-24.951v-5.545zm-27.722-16.634h36.039v2.772h-36.039v-2.772zm0 13.862v-8.317h13.861v5.544h8.315v-2.772h-5.543v-2.772h8.317v8.317h-13.861v-5.545h-8.315v5.545h-2.774zm5.544-2.773h2.773v2.773h-2.773v-2.773zm30.495 2.773h-8.317v-8.317h11.089v-5.545h2.774v11.089h2.77V99.723h2.774v11.089h2.772V99.723h2.774v13.862H436.96v-5.545h-8.315v2.772h5.543v2.773zm-91.692 2.772h24.951v5.545h-24.951v-5.545zm27.725 0h24.949v5.545h-24.949v-5.545zm-27.725-16.634h36.04v2.772h-36.04v-2.772zm0 13.862v-8.317h13.863v5.544h8.315v-2.772h-5.543v-2.772h8.317v8.317h-13.863v-5.545h-8.316v5.545h-2.773zm5.546-2.773h2.771v2.773h-2.771v-2.773zm30.494 2.773h-8.318v-8.317h11.09v-5.545h2.775v11.089h2.77V99.723h2.773v11.089h2.773V99.723h2.771v13.862h-13.862v-5.545h-8.315v2.772h5.543v2.773zm-91.691 2.772h24.952v5.545h-24.952v-5.545zm27.722 0h24.951v5.545h-24.951v-5.545zm-27.722-16.634h36.04v2.772h-36.04v-2.772zm0 13.862v-8.317h13.862v5.544h8.316v-2.772h-5.545v-2.772h8.319v8.317h-13.864v-5.545h-8.315v5.545h-2.773zm5.545-2.773h2.771v2.773h-2.771v-2.773zm30.495 2.773h-8.318v-8.317h11.088v-5.545h2.774v11.089h2.771V99.723h2.774v11.089h2.771V99.723h2.774v13.862h-13.864v-5.545h-8.315v2.772h5.545v2.773zm-91.692 2.772h24.95v5.545h-24.95v-5.545zm27.723 0h24.949v5.545h-24.949v-5.545zm-27.723-16.634h36.04v2.772h-36.04v-2.772zm0 13.862v-8.317h13.861v5.544h8.317v-2.772h-5.545v-2.772h8.32v8.317h-13.865v-5.545h-8.316v5.545h-2.772zm5.544-2.773h2.773v2.773h-2.773v-2.773zm30.496 2.773h-8.317v-8.317h11.088v-5.545h2.773v11.089h2.771V99.723h2.774v11.089h2.772V99.723h2.774v13.862h-13.864v-5.545h-8.314v2.772h5.543v2.773zm-91.693 2.772h24.952v5.545H175.54v-5.545zm27.725 0h24.949v5.545h-24.949v-5.545zM175.54 99.723h36.042v2.772H175.54v-2.772zm0 13.862v-8.317h13.863v5.544h8.317v-2.772h-5.546v-2.772h8.318v8.317H186.63v-5.545h-8.316v5.545h-2.774zm5.544-2.773h2.773v2.773h-2.773v-2.773zm30.498 2.773h-8.317v-8.317h11.087v-5.545h2.773v11.089h2.772V99.723h2.772v11.089h2.773V99.723h2.772v13.862h-13.862v-5.545h-8.316v2.772h5.546v2.773zm-91.693 2.772h24.95v5.545h-24.95v-5.545zm27.724 0h24.95v5.545h-24.95v-5.545zm-27.724-16.634h36.039v2.772h-36.039v-2.772zm0 13.862v-8.317h13.862v5.544h8.317v-2.772h-5.546v-2.772h8.318v8.317h-13.862v-5.545h-8.318v5.545h-2.771zm5.544-2.773h2.772v2.773h-2.772v-2.773zm30.495 2.773h-8.315v-8.317h11.088v-5.545h2.774v11.089h2.771V99.723h2.774v11.089h2.77V99.723h2.773v13.862h-13.862v-5.545h-8.316v2.772h5.543v2.773zm-91.692 2.772h24.951v5.545H64.236v-5.545zm27.725 0h24.951v5.545H91.961v-5.545zM64.236 99.723h36.041v2.772H64.236v-2.772zm0 13.862v-8.317h13.863v5.544h8.316v-2.772h-5.544v-2.772h8.317v8.317H75.326v-5.545h-8.317v5.545h-2.773zm5.546-2.773h2.772v2.773h-2.772v-2.773zm30.495 2.773H91.96v-8.317h11.09v-5.545h2.771v11.089h2.773V99.723h2.772v11.089h2.772V99.723h2.774v13.862H103.05v-5.545h-8.318v2.772h5.545v2.773zm-91.692 2.772h24.951v5.545H8.585v-5.545zm27.724 0h24.95v5.545h-24.95v-5.545zM8.585 99.723h36.041v2.772H8.585v-2.772zm0 13.862v-8.317h13.862v5.544h8.316v-2.772h-5.545v-2.772h8.318v8.317H19.675v-5.545h-8.317v5.545H8.585zm5.544-2.773h2.773v2.773h-2.773v-2.773zm30.497 2.773h-8.317v-8.317h11.088v-5.545h2.773v11.089h2.773V99.723h2.772v11.089h2.772V99.723h2.772v13.862H47.397v-5.545H39.08v2.772h5.546v2.773zM512.68 235.169v5.547h-5.288v-5.547h5.288zm0 8.317v2.773h-5.288v-2.773h5.288zm0 5.545v2.773h-2.516v5.544h-2.772v-8.317h5.288zM.32 257.348v-2.772h2.516v-11.09h2.772v13.862H.32zm0-16.632v-5.547h5.288v5.547H.32zm451.628 2.77h36.039v2.773h-36.039v-2.773zm0 13.862v-8.317h13.862v5.545h8.316v-2.772h-5.544v-2.773h8.315v8.317h-13.862v-5.544h-8.315v5.544h-2.772zm5.544-2.772h2.773v2.772h-2.773v-2.772zm30.495 2.772h-8.317v-8.317h11.089v-5.545h2.773v11.09h2.773v-11.09h2.771v11.09h2.773v-11.09h2.772v13.862h-13.862v-5.544h-8.317v2.772h5.545v2.772zm-36.039-22.179h24.949v5.547h-24.949v-5.547zm27.722 0h24.951v5.547H479.67v-5.547zm-83.169 8.317h36.039v2.773h-36.039v-2.773zm0 13.862v-8.317h13.862v5.545h8.316v-2.772h-5.543v-2.773h8.316v8.317h-13.863v-5.544h-8.316v5.544h-2.772zm5.544-2.772h2.773v2.772h-2.773v-2.772zm30.495 2.772h-8.317v-8.317h11.09v-5.545h2.773v11.09h2.772v-11.09h2.773v11.09h2.771v-11.09h2.773v13.862h-13.862v-5.544h-8.318v2.772h5.545v2.772zm-36.039-22.179h24.951v5.547h-24.951v-5.547zm27.723 0h24.951v5.547h-24.951v-5.547zm-83.169 8.317h36.041v2.773h-36.041v-2.773zm-.001 13.862v-8.317h13.863v5.545h8.317v-2.772h-5.545v-2.773h8.317v8.317h-13.862v-5.544h-8.316v5.544h-2.774zm5.546-2.772h2.772v2.772H346.6v-2.772zm30.496 2.772h-8.317v-8.317h11.089v-5.545h2.772v11.09h2.771v-11.09h2.774v11.09h2.772v-11.09h2.771v13.862h-13.86v-5.544h-8.318v2.772h5.546v2.772zm-36.041-22.179h24.951v5.547h-24.951v-5.547zm27.724 0h24.95v5.547h-24.95v-5.547zm-83.169 8.317h36.039v2.773H285.61v-2.773zm-.002 13.862v-8.317h13.863v5.545h8.317v-2.772h-5.544v-2.773h8.315v8.317h-13.862v-5.544h-8.315v5.544h-2.774zm5.546-2.772h2.771v2.772h-2.771v-2.772zm30.495 2.772h-8.317v-8.317h11.089v-5.545h2.773v11.09h2.77v-11.09h2.774v11.09h2.772v-11.09h2.773v13.862h-13.862v-5.544h-8.318v2.772h5.546v2.772zm-36.039-22.179h24.95v5.547h-24.95v-5.547zm27.722 0h24.951v5.547h-24.951v-5.547zm-83.169 8.317h36.039v2.773h-36.039v-2.773zm0 13.862v-8.317h13.862v5.545h8.316v-2.772h-5.543v-2.773h8.317v8.317h-13.864v-5.544h-8.314v5.544h-2.774zm5.544-2.772h2.773v2.772h-2.773v-2.772zm30.495 2.772h-8.317v-8.317h11.09v-5.545h2.774v11.09h2.77v-11.09h2.774v11.09h2.77v-11.09h2.774v13.862h-13.862v-5.544h-8.316v2.772h5.543v2.772zm-36.039-22.179h24.952v5.547h-24.952v-5.547zm27.722 0h24.952v5.547h-24.952v-5.547zm-83.168 8.317h36.039v2.773h-36.039v-2.773zm0 13.862v-8.317h13.862v5.545h8.318v-2.772h-5.546v-2.773h8.317v8.317h-13.862v-5.544h-8.316v5.544h-2.773zm5.545-2.772h2.772v2.772h-2.772v-2.772zm30.494 2.772h-8.315v-8.317h11.088v-5.545h2.774v11.09h2.77v-11.09h2.774v11.09h2.771v-11.09h2.774v13.862h-13.863v-5.544h-8.317v2.772h5.544v2.772zm-36.039-22.179h24.951v5.547h-24.951v-5.547zm27.723 0h24.95v5.547h-24.95v-5.547zm-83.169 8.317h36.04v2.773h-36.04v-2.773zm.001 13.862v-8.317h13.86v5.545h8.318v-2.772h-5.546v-2.773h8.317v8.317H130.36v-5.544h-8.317v5.544h-2.771zm5.543-2.772h2.772v2.772h-2.772v-2.772zm30.496 2.772h-8.317v-8.317h11.089v-5.545h2.773v11.09h2.771v-11.09h2.773v11.09h2.772v-11.09h2.774v13.862h-13.863v-5.544h-8.317v2.772h5.545v2.772zm-36.04-22.179h24.95v5.547h-24.95v-5.547zm27.723 0h24.951v5.547h-24.951v-5.547zm-83.169 8.317h36.039v2.773H63.825v-2.773zm0 13.862v-8.317h13.862v5.545h8.318v-2.772H80.46v-2.773h8.317v8.317H74.914v-5.544h-8.316v5.544h-2.773zm5.544-2.772h2.773v2.772h-2.773v-2.772zm30.495 2.772h-8.316v-8.317h11.089v-5.545h2.774v11.09h2.771v-11.09h2.773v11.09h2.772v-11.09h2.772v13.862h-13.862v-5.544h-8.316v2.772h5.543v2.772zm-36.039-22.179h24.951v5.547H63.825v-5.547zm27.723 0h24.951v5.547H91.548v-5.547zm-83.169 8.317H44.42v2.773H8.379v-2.773zm0 13.862v-8.317h13.862v5.545h8.317v-2.772h-5.545v-2.773h8.317v8.317H19.468v-5.544h-8.317v5.544H8.379zm5.545-2.772h2.771v2.772h-2.771v-2.772zm30.496 2.772h-8.317v-8.317H47.19v-5.545h2.775v11.09h2.77v-11.09h2.773v11.09h2.772v-11.09h2.772v13.862H47.19v-5.544h-8.316v2.772h5.546v2.772zM8.379 235.169H33.33v5.547H8.379v-5.547zm27.724 0h24.949v5.547H36.103v-5.547z"
        />
        <path
          fill="#DA0000"
          d="M284.05 208.005a34.02 34.02 0 0017.016-29.469c0-15.61-10.626-29.233-25.765-33.024a44.58 44.58 0 0117.783 35.617c0 9.7-3.173 19.129-9.034 26.876zm-55.095 0a34.021 34.021 0 01-17.016-29.469c0-15.61 10.625-29.233 25.765-33.024a44.576 44.576 0 00-17.782 35.617c0 9.7 3.173 19.129 9.033 26.876zm27.523-70.659a6.07 6.07 0 01-5.254 3.031 6.096 6.096 0 01-5.978-4.968 6.496 6.496 0 00-.455 2.393 6.432 6.432 0 006.433 6.432 6.515 6.515 0 005.278-2.733 6.519 6.519 0 005.28 2.733 6.432 6.432 0 006.432-6.432c0-.809-.151-1.635-.455-2.393a6.094 6.094 0 01-5.977 4.968c-2.172 0-4.226-1.162-5.304-3.031zm24.444 78.454a40.927 40.927 0 01-12.575 1.989c-2.854 0-5.637-.296-8.325-.857l-.055 1.388-3.467 4.771-3.467-4.771-.055-1.386a40.802 40.802 0 01-20.895-1.134 44.44 44.44 0 0017.438-2.635c-12.96-6.791-21.808-20.373-21.808-36.01a40.655 40.655 0 0114.129-30.8 44.46 44.46 0 00-7.646 24.94c0 14.826 7.249 27.963 18.394 36.065l-1.348-33.298-.004-26.19a13.708 13.708 0 005.262-4.413 13.708 13.708 0 005.262 4.413l-.004 26.19-1.348 33.301c11.148-8.1 18.399-21.239 18.399-36.068a44.469 44.469 0 00-7.646-24.94 40.656 40.656 0 0114.13 30.8c0 15.637-8.849 29.219-21.808 36.01a44.43 44.43 0 0017.437 2.635z"
        />
        <path
          fill="#CCC"
          d="M28.48 0h456.04c7.833 0 14.953 3.204 20.115 8.365C509.796 13.527 513 20.648 513 28.48v300.112c0 7.832-3.204 14.952-8.365 20.114-5.162 5.161-12.282 8.365-20.115 8.365H28.48c-7.833 0-14.953-3.204-20.115-8.365C3.204 343.544 0 336.424 0 328.592V28.48c0-7.832 3.204-14.953 8.365-20.115C13.527 3.204 20.647 0 28.48 0zm456.04.641H28.48c-7.656 0-14.616 3.132-19.661 8.178C3.773 13.864.641 20.824.641 28.48v300.112c0 7.655 3.132 14.615 8.178 19.661 5.045 5.045 12.005 8.177 19.661 8.177h456.04c7.656 0 14.616-3.132 19.661-8.177 5.046-5.046 8.178-12.006 8.178-19.661V28.48c0-7.656-3.132-14.616-8.178-19.661C499.136 3.773 492.176.641 484.52.641z"
        />
      </g>
    </svg>
  );
}

export function IconIranFlagCircle({ fillColor, ...props }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 512"
    >
      <g fillRule="nonzero">
        <path
          fill="#fff"
          d="M256.001 19.596c65.278 0 124.383 26.466 167.163 69.243 42.776 42.779 69.243 101.884 69.243 167.162s-26.467 124.383-69.246 167.16c-42.777 42.779-101.882 69.246-167.16 69.246-65.278 0-124.383-26.467-167.162-69.243-42.777-42.78-69.243-101.885-69.243-167.163S46.062 131.618 88.839 88.839c42.779-42.777 101.884-69.243 167.162-69.243z"
        />
        <path
          fill="#DA0000"
          d="M453.474 344.645c-33.862 75.319-109.54 127.764-197.473 127.764-87.927 0-163.593-52.431-197.463-127.737l.008.018h394.907l.021-.045z"
        />
        <path
          fill="#239F40"
          d="M58.254 167.98h395.491C420.02 92.331 344.173 39.594 256.001 39.594c-88.175 0-164.024 52.737-197.747 128.386z"
        />
        <path
          fill="#fff"
          d="M440.39 142.683a218.21 218.21 0 014.124 6.991v5.936h3.232c.718 1.364 1.42 2.74 2.108 4.125h-9.464v-8.249h-12.37v4.124h8.245v4.125h-12.369v-12.37h16.494v-4.682zm11.46 21.173a219.502 219.502 0 013.69 8.248h-31.644v-8.248h27.954zm-395.388 8.248a217.862 217.862 0 013.688-8.248h28.538v8.248H56.462zm5.686-12.369c.591-1.19 1.187-2.374 1.801-3.549v3.549h-1.801zm4.325-8.249a230.244 230.244 0 012.335-4.121h3.389v8.245h12.37v-4.124h-8.248v-4.121h12.372v12.37H68.073v-8.249h-1.6zm4.789-8.245c.847-1.385 1.706-2.76 2.582-4.124h31.338v4.124h-33.92zm311.401 20.615h37.109v8.248h-37.109v-8.248zm0-24.739h53.602v4.124h-53.602v-4.124zm0 20.618v-12.37h20.618v8.245h12.367v-4.124h-8.246v-4.121h12.373v12.37h-20.621v-8.249h-12.367v8.249h-4.124zm8.245-4.125h4.125v4.125h-4.125v-4.125zm-91.014 8.246h37.108v8.248h-37.108v-8.248zm41.229 0h37.109v8.248h-37.109v-8.248zm-41.229-24.739h53.602v4.124h-53.602v-4.124zm0 20.618v-12.37h20.615v8.245h12.369v-4.124h-8.248v-4.121h12.372v12.37h-20.618v-8.249h-12.366v8.249h-4.124zm8.245-4.125h4.121v4.125h-4.121v-4.125zm45.357 4.125h-12.373v-12.37h16.494v-8.248h4.124v16.493h4.122v-16.493h4.123v16.493h4.122v-16.493h4.127v20.618h-20.618v-8.249h-12.369v4.124h8.248v4.125zm-136.375 4.121h37.109v8.248h-37.109v-8.248zm41.233 0h37.108v8.248h-37.108v-8.248zm-41.233-24.739h53.603v4.124h-53.603v-4.124zm0 20.618v-12.37h20.615v8.245h12.372v-4.124h-8.248v-4.121h12.373v12.37h-20.618v-8.249h-12.37v8.249h-4.124zm8.246-4.125h4.124v4.125h-4.124v-4.125zm45.357 4.125h-12.37v-12.37h16.491v-8.248h4.127v16.493h4.121v-16.493h4.124v16.493h4.121v-16.493h4.127v20.618h-20.62v-8.249h-12.367v4.124h8.246v4.125zm-136.375 4.121h37.111v8.248h-37.111v-8.248zm41.235 0h37.109v8.248h-37.109v-8.248zm-41.235-24.739h53.605v4.124h-53.605v-4.124zm0 20.618v-12.37h20.621v8.245h12.366v-4.124h-8.245v-4.121h12.369v12.37h-20.617v-8.249h-12.367v8.249h-4.127zm8.248-4.125h4.124v4.125h-4.124v-4.125zm45.357 4.125h-12.37v-12.37h16.491v-8.248h4.125v16.493h4.121v-16.493h4.124v16.493h4.124v-16.493h4.124v20.618h-20.618v-8.249h-12.369v4.124h8.248v4.125zm-95.142 4.121h37.109v8.248H92.812v-8.248zm12.37-4.121h-12.37v-12.37h16.494v-8.248h4.124v16.493h4.121v-16.493h4.127v16.493h4.121v-16.493h4.122v20.618h-20.615v-8.249h-12.37v4.124h8.246v4.125zM455.256 340.565c-1.18 2.781-2.42 5.53-3.716 8.249h-29.787v-8.249h33.503zm-5.735 12.37a208.676 208.676 0 01-3.029 5.83v-5.83h3.029zm-7.151 13.096a215.895 215.895 0 01-4.124 6.716v-7.443h-12.369v4.125h8.245v4.124h-12.369v-12.37h16.493v-8.248h4.124v13.096zm-368.086 7.522a225.376 225.376 0 01-2.606-4.124h11.968v-4.125H75.4v-4.121h12.37v12.37H74.284zm-3.008-4.771a215.553 215.553 0 01-4.428-7.599h4.428v7.599zm-6.669-11.723a210.984 210.984 0 01-2.128-4.124h41.785v4.124H64.607zm-4.144-8.245a209.415 209.415 0 01-3.717-8.249H87.77v8.249H60.463zm320.057 4.121h53.602v4.124H380.52v-4.124zm0 20.618v-12.37h20.618v8.246h12.366v-4.125h-8.245v-4.121h12.37v12.37H397.01v-8.249h-12.366v8.249h-4.124zm8.248-4.124h4.121v4.124h-4.121v-4.124zm-8.248-28.864h37.109v8.249H380.52v-8.249zm-82.466 12.37h53.603v4.124h-53.603v-4.124zm0 20.618v-12.37h20.618v8.246h12.367v-4.125h-8.243v-4.121h12.367v12.37h-20.615v-8.249h-12.369v8.249h-4.125zm8.249-4.124h4.121v4.124h-4.121v-4.124zm45.354 4.124h-12.37v-12.37h16.494v-8.248h4.124v16.494h4.121v-16.494h4.124v16.494h4.122v-16.494h4.127v20.618h-20.618v-8.249h-12.37v4.125h8.246v4.124zm-53.603-32.988h37.112v8.249h-37.112v-8.249zm41.233 0h37.112v8.249h-37.112v-8.249zm-123.698 12.37h53.602v4.124h-53.602v-4.124zm0 20.618v-12.37h20.618v8.246h12.37v-4.125h-8.246v-4.121H252.7v12.37h-20.617v-8.249h-12.367v8.249h-4.127zm8.248-4.124h4.125v4.124h-4.125v-4.124zm45.354 4.124h-12.369v-12.37h16.494v-8.248h4.124v16.494h4.121v-16.494h4.124v16.494h4.121v-16.494h4.127v20.618h-20.617v-8.249h-12.37v4.125h8.245v4.124zm-53.602-32.988H252.7v8.249h-37.111v-8.249zm41.233 0h37.111v8.249h-37.111v-8.249zm-123.698 12.37h53.602v4.124h-53.602v-4.124zm0 20.618v-12.37h20.617v8.246h12.37v-4.125h-8.245v-4.121h12.369v12.37h-20.617v-8.249h-12.367v8.249h-4.127zm8.248-4.124h4.124v4.124h-4.124v-4.124zm45.354 4.124H174.36v-12.37h16.49v-8.248h4.124v16.494h4.121v-16.494h4.128v16.494h4.121v-16.494h4.124v20.618H190.85v-8.249h-12.366v4.125h8.242v4.124zm-53.602-32.988h37.111v8.249h-37.111v-8.249zm41.232 0h37.112v8.249h-37.112v-8.249zm-70.092 32.988h-12.37v-12.37h16.491v-8.248h4.127v16.494h4.121v-16.494h4.124v16.494h4.121v-16.494h4.125v20.618h-20.618v-8.249H96.018v4.125h8.246v4.124zm-12.37-32.988h37.109v8.249H91.894v-8.249z"
        />
        <path
          fill="#DA0000"
          d="M295.736 300.164a50.597 50.597 0 0025.308-43.829c0-23.217-15.804-43.479-38.32-49.114a66.294 66.294 0 0126.448 52.971 66.242 66.242 0 01-13.436 39.972zm-81.942 0a50.597 50.597 0 01-25.308-43.829c0-23.217 15.804-43.479 38.319-49.114a66.294 66.294 0 00-26.448 52.971 66.243 66.243 0 0013.437 39.972zm40.934-105.09a9.028 9.028 0 01-7.814 4.508 9.066 9.066 0 01-8.891-7.389 9.643 9.643 0 00-.677 3.557 9.567 9.567 0 009.568 9.567c3.105 0 6.036-1.527 7.851-4.064 1.816 2.537 4.746 4.064 7.851 4.064a9.567 9.567 0 009.568-9.567c0-1.203-.225-2.43-.676-3.557-.802 4.283-4.559 7.389-8.892 7.389-3.23 0-6.285-1.729-7.888-4.508zm36.357 116.684a60.876 60.876 0 01-18.705 2.958c-4.243 0-8.383-.439-12.379-1.274l-.084 2.062-5.156 7.097-5.156-7.097-.083-2.06a60.553 60.553 0 01-12.372 1.272 60.876 60.876 0 01-18.705-2.958c1.052.05 2.175.077 3.227.077a66.104 66.104 0 0022.707-3.996c-19.272-10.102-32.433-30.301-32.433-53.558a60.464 60.464 0 0121.014-45.808 66.137 66.137 0 00-11.371 37.092c0 22.052 10.781 41.591 27.356 53.638l-2.005-49.522-.005-38.954a20.357 20.357 0 007.826-6.562 20.353 20.353 0 007.827 6.562l-.005 38.954-2.006 49.528c16.58-12.046 27.365-31.588 27.365-53.644a66.145 66.145 0 00-11.371-37.092 60.467 60.467 0 0121.013 45.808c0 23.257-13.16 43.456-32.433 53.558a66.104 66.104 0 0022.707 3.996c1.052 0 2.175-.027 3.227-.077z"
        />
      </g>
    </svg>
  );
}
export function IconDisLike({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none">
        <path
          fill={fillColor}
          d="m15 14l-.493.082A.5.5 0 0 1 15 13.5zM4 14v.5a.5.5 0 0 1-.5-.5zm16.522-2.392l.49-.098zM6 3.5h11.36v1H6zm12.56 11H15v-1h3.56zm-3.067-.582l.806 4.835l-.986.165l-.806-4.836zM14.82 20.5h-.213v-1h.213zm-3.126-1.558l-2.515-3.774l.832-.555l2.515 3.774zM7.93 14.5H4v-1h3.93zM3.5 14V6h1v8zm16.312-8.49l1.2 6l-.98.196l-1.2-6zM9.178 15.168A1.5 1.5 0 0 0 7.93 14.5v-1a2.5 2.5 0 0 1 2.08 1.113zm7.121 3.585a1.5 1.5 0 0 1-1.48 1.747v-1a.5.5 0 0 0 .494-.582zM18.56 13.5a1.5 1.5 0 0 0 1.471-1.794l.98-.196a2.5 2.5 0 0 1-2.45 2.99zm-1.2-10a2.5 2.5 0 0 1 2.452 2.01l-.98.196A1.5 1.5 0 0 0 17.36 4.5zm-2.754 17a3.5 3.5 0 0 1-2.913-1.558l.832-.555a2.5 2.5 0 0 0 2.08 1.113zM6 4.5A1.5 1.5 0 0 0 4.5 6h-1A2.5 2.5 0 0 1 6 3.5z"
        />
        <path stroke={fillColor} d="M8 14V4" />
      </g>
    </svg>
  );
}
export function IconLike({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none">
        <path
          fill={fillColor}
          d="m15 10l-.493-.082A.5.5 0 0 0 15 10.5zM4 10v-.5a.5.5 0 0 0-.5.5zm16.522 2.392l.49.098zM6 20.5h11.36v-1H6zm12.56-11H15v1h3.56zm-3.067.582l.806-4.835l-.986-.165l-.806 4.836zM14.82 3.5h-.213v1h.213zm-3.126 1.559L9.178 8.832l.832.555l2.515-3.774zM7.93 9.5H4v1h3.93zM3.5 10v8h1v-8zm16.312 8.49l1.2-6l-.98-.196l-1.2 6zM9.178 8.832A1.5 1.5 0 0 1 7.93 9.5v1a2.5 2.5 0 0 0 2.08-1.113zm7.121-3.585A1.5 1.5 0 0 0 14.82 3.5v1a.5.5 0 0 1 .494.582zM18.56 10.5a1.5 1.5 0 0 1 1.471 1.794l.98.196a2.5 2.5 0 0 0-2.45-2.99zm-1.2 10a2.5 2.5 0 0 0 2.452-2.01l-.98-.196A1.5 1.5 0 0 1 17.36 19.5zm-2.754-17a3.5 3.5 0 0 0-2.913 1.559l.832.554a2.5 2.5 0 0 1 2.08-1.113zM6 19.5A1.5 1.5 0 0 1 4.5 18h-1A2.5 2.5 0 0 0 6 20.5z"
        />
        <path stroke={fillColor} d="M8 10v10" />
      </g>
    </svg>
  );
}

export function IconComment({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M12 21a9 9 0 1 0-9-9c0 1.488.36 2.891 1 4.127L3 21l4.873-1c1.236.64 2.64 1 4.127 1" />
        <path d="m15 10l-4 4l-2-2" />
      </g>
    </svg>
  );
}
export function IconCard({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none" stroke={fillColor} strokeWidth="1.5">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11 9h11M2 11l2.807-3.157A4 4 0 0 1 7.797 6.5H8m-6 13h5.5l4-3s.81-.547 2-1.5c2.5-2 0-5.166-2.5-3.5C8.964 12.857 7 14 7 14"
        />
        <path d="M8 13.5V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-6.5" />
      </g>
    </svg>
  );
}

export function IconCoinBag({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        fill={fillColor}
        d="M21.6 29a1 1 0 0 0-1-1h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1"
        className="clr-i-outline clr-i-outline-path-1"
      />
      <path
        fill={fillColor}
        d="M22.54 24h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
        className="clr-i-outline clr-i-outline-path-2"
      />
      <path
        fill={fillColor}
        d="M22 32h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
        className="clr-i-outline clr-i-outline-path-3"
      />
      <path
        fill={fillColor}
        d="M32.7 32h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2"
        className="clr-i-outline clr-i-outline-path-4"
      />
      <path
        fill={fillColor}
        d="M33.7 28h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2"
        className="clr-i-outline clr-i-outline-path-5"
      />
      <path
        fill={fillColor}
        d="M33.74 26a28 28 0 0 0-2.82-10.12a20.24 20.24 0 0 0-6.32-7.17L27 3.42a1 1 0 0 0-.07-1a1 1 0 0 0-.8-.42H9.8a1 1 0 0 0-.91 1.42l2.45 5.31a20.3 20.3 0 0 0-6.28 7.15c-2.15 4-2.82 8.89-3 12.28a3.6 3.6 0 0 0 1 2.71a3.8 3.8 0 0 0 2.74 1.07H12V30H5.72a1.68 1.68 0 0 1-1.21-.52a1.62 1.62 0 0 1-.45-1.23c.14-2.61.69-7.58 2.76-11.45a18 18 0 0 1 6.26-6.8h1a31 31 0 0 0-1.87 2.92a23 23 0 0 0-1.47 3.34l1.37.92a24 24 0 0 1 1.49-3.47A29 29 0 0 1 16.05 10h1a21.5 21.5 0 0 1 1.41 5a22.5 22.5 0 0 1 .32 3.86l1.58-1.11a24 24 0 0 0-.32-3A25 25 0 0 0 18.76 10h.78l.91-2h-7.24l-1.85-4h13.21l-2.5 5.47a10 10 0 0 1 1.23.78a18.6 18.6 0 0 1 5.86 6.57A26.6 26.6 0 0 1 31.73 26Z"
        className="clr-i-outline clr-i-outline-path-6"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
}
export function IconTags({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
      <g fill="none" fillRule="evenodd" transform="translate(1 3)">
        <path
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.914.5H15.5a2 2 0 0 1 2 2v3.586a1 1 0 0 1-.293.707l-6.793 6.793a2 2 0 0 1-2.828 0l-3.172-3.172a2 2 0 0 1 0-2.828L11.207.793A1 1 0 0 1 11.914.5"
        />
        <path
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m7.5 13.5l-2.013 1.006A2 2 0 0 1 2.72 13.42L1.105 9.114a2 2 0 0 1 .901-2.45L9.5 2.5"
        />
        <rect width="2" height="2" x="14" y="2" fill={fillColor} rx="1" />
      </g>
    </svg>
  );
}
export function IconFast({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M15 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m-1 2h1.5v3.78l2.33 2.33l-1.06 1.06L14 12.4zM2 18a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3.83c.31.71.71 1.38 1.17 2zm1-5a1 1 0 0 1-1-1a1 1 0 0 1 1-1h2.05L5 12l.05 1zm1-5a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3c-.46.62-.86 1.29-1.17 2z"
      />
    </svg>
  );
}

export function IconSecurity({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill={fillColor}
        d="M14 16.59L11.41 14L10 15.41l4 4l8-8L20.59 10z"
      />
      <path
        fill={fillColor}
        d="m16 30l-6.176-3.293A10.98 10.98 0 0 1 4 17V4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a10.98 10.98 0 0 1-5.824 9.707ZM6 4v13a8.99 8.99 0 0 0 4.766 7.942L16 27.733l5.234-2.79A8.99 8.99 0 0 0 26 17V4Z"
      />
    </svg>
  );
}
export function IconPhone({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m9.159 5.712l-.403-.906c-.263-.592-.395-.888-.592-1.115a2 2 0 0 0-.928-.603C6.949 3 6.625 3 5.976 3c-.948 0-1.422 0-1.82.182a2.12 2.12 0 0 0-1.061 1.169c-.143.413-.102.838-.02 1.689q1.31 13.575 14.886 14.885c.85.082 1.275.123 1.689-.02a2.12 2.12 0 0 0 1.168-1.06c.182-.399.182-.873.182-1.821c0-.649 0-.973-.088-1.26a2 2 0 0 0-.603-.928c-.226-.197-.523-.328-1.115-.592l-.906-.402c-.642-.285-.962-.428-1.288-.459a2 2 0 0 0-.919.128c-.305.119-.574.343-1.114.793c-.537.447-.805.67-1.133.79a2.16 2.16 0 0 1-.981.101c-.346-.05-.61-.192-1.14-.475c-1.645-.88-2.553-1.787-3.433-3.433c-.283-.53-.424-.794-.475-1.14a2.16 2.16 0 0 1 .1-.98c.12-.329.344-.597.791-1.134c.45-.54.675-.809.793-1.114c.114-.292.158-.607.128-.919c-.03-.325-.173-.646-.459-1.288"
        color={fillColor}
      />
    </svg>
  );
}
export function IconAboutUs({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color={fillColor}
      >
        <path d="M14 9h4m-4 3.5h3" />
        <rect width="20" height="18" x="2" y="3" rx="5" />
        <path d="M5 16c1.208-2.581 5.712-2.75 7 0m-1.5-7a2 2 0 1 1-4 0a2 2 0 0 1 4 0" />
      </g>
    </svg>
  );
}

export function IconPolicy({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M20 12V5.749a.6.6 0 0 0-.176-.425l-3.148-3.148A.6.6 0 0 0 16.252 2H4.6a.6.6 0 0 0-.6.6v18.8a.6.6 0 0 0 .6.6H13M8 10h8M8 6h4m-4 8h3" />
        <path d="M16 2v3.4a.6.6 0 0 0 .6.6H20m-.008 9.125l2.556.649c.266.068.453.31.445.584C22.821 22.116 19.5 23 19.5 23s-3.321-.884-3.493-6.642a.59.59 0 0 1 .445-.584l2.556-.649c.323-.082.661-.082.984 0" />
      </g>
    </svg>
  );
}

export function IconDoubleArrowLeft({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="m7.825 12l3.875 3.9q.275.275.288.688t-.288.712q-.275.275-.7.275t-.7-.275l-4.6-4.6q-.15-.15-.213-.325T5.426 12t.063-.375t.212-.325l4.6-4.6q.275-.275.688-.287t.712.287q.275.275.275.7t-.275.7zm6.6 0l3.875 3.9q.275.275.288.688t-.288.712q-.275.275-.7.275t-.7-.275l-4.6-4.6q-.15-.15-.213-.325T12.026 12t.063-.375t.212-.325l4.6-4.6q.275-.275.688-.287t.712.287q.275.275.275.7t-.275.7z"
      />
    </svg>
  );
}

export function IconPlayFill({ ...props }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M5 5.274c0-1.707 1.826-2.792 3.325-1.977l12.362 6.727c1.566.852 1.566 3.1 0 3.952L8.325 20.702C6.826 21.518 5 20.432 5 18.726z"
      />
    </svg>
  );
}
export function IconLock({ ...props }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M8 10V7c0-2.21 1.79-4 4-4s4 1.79 4 4v3m-4 5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 0v3m-5.4-8h10.8c.88 0 1.6.72 1.6 1.6v7c0 1.32-1.08 2.4-2.4 2.4H7.4C6.08 21 5 19.92 5 18.6v-7c0-.88.72-1.6 1.6-1.6"
      />
    </svg>
  );
}
export function IconForbidden({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M4 12c0-4.4 3.6-8 8-8c1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12m8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8"
      />
    </svg>
  );
}
export function IconPeople({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="m21.11 22.53l-4.514-4.513v.599h-14v-1.647q0-.696.36-1.197q.361-.5.97-.8q1.301-.62 2.584-.988q1.282-.368 3.086-.368q.935 0 1.651.108q.717.109 1.343.288l-2.646-2.646q-.088.019-.174.019h-.174q-1.237 0-2.118-.882t-.882-2.118V8.21q0-.086.02-.174l-4.73-4.73l.714-.713l19.223 19.223zm-3.864-8.572q.737.15 1.42.416t1.35.599q.65.327 1.019.837t.369 1.113v1.635h-.029l-3.02-3.02q-.166-.46-.44-.86q-.274-.401-.669-.72m-7.65.657q-1.592 0-2.833.319q-1.24.318-2.36.916q-.455.24-.631.504q-.176.263-.176.615v.646h12v-.598l-1.483-1.483q-.969-.459-2.056-.689t-2.46-.23m4.203-3.632q.379-.566.588-1.231t.208-1.368q0-.818-.285-1.563q-.286-.744-.769-1.39q.081-.029.162-.038t.162-.008q1.237 0 2.118.88t.882 2.12q0 1.174-.786 2.01t-1.897.97zm-1.43-1.431l-.812-.811q.019-.089.029-.169t.01-.187q0-.825-.588-1.413t-1.413-.587q-.107 0-.187.01q-.08.009-.168.028l-.812-.811q.285-.104.568-.166q.283-.061.6-.061q1.237 0 2.118.88t.881 2.12q0 .316-.061.6q-.062.282-.166.567M10.431 7.55"
      />
    </svg>
  );
}
export function IconDisactive({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M6.5 11C9 11 11 9 11 6.5S9 2 6.5 2S2 4 2 6.5S4 11 6.5 11M3.92 5L8 9.09c-.42.26-.94.41-1.5.41c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5M9.5 6.5c0 .56-.15 1.08-.41 1.5L5 3.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3M10 12c.81-.54 1.5-1.23 2-2.03V19h7V5h-6.17A7 7 0 0 0 12 3h7c1.11 0 2 .89 2 2v14h1v2H2v-2h8zm6-1h2v2h-2z"
      />
    </svg>
  );
}
export function IconHourGlass({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M21.11 22.53L19.579 21H5v-1h1.808v-3q0-1.91 1.097-3.238t2.564-1.724v-.096q-.934-.269-2.026-1.18T7.002 8.423L1.887 3.308l.713-.714l19.223 19.223zm-6.79-11.034l-.693-.686q1.01-.571 1.788-1.6q.777-1.03.777-2.21V4H7.808v.99l-.798-.798V4h-.193l-1-1H19v1h-1.808v3q0 1.35-.87 2.552q-.872 1.202-2.003 1.944M7.808 20h8.384v-2.386l-4.813-4.795q-1.356.206-2.463 1.312Q7.807 15.237 7.807 17zm9.384 0h1.347l-1.347-1.577z"
      />
    </svg>
  );
}
export function IconPersonSupport({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill={fillColor}
        d="M10 14.5a2 2 0 0 1-1.994-1.84A6.002 6.002 0 0 1 10 1a6 6 0 0 1 5.98 5.5a.47.47 0 0 1-.48.5a.54.54 0 0 1-.525-.5a5 5 0 1 0-6.79 5.16A2 2 0 1 1 10 14.5M5.009 12H5.1c.39.381.823.717 1.292 1H5.009C4.448 13 4 13.447 4 14c0 1.309.622 2.284 1.673 2.953C6.743 17.636 8.265 18 10 18s3.257-.364 4.327-1.047C15.377 16.283 16 15.31 16 14a1 1 0 0 0-1-1h-2.041a3 3 0 0 0 0-1H15a2 2 0 0 1 2 2c0 1.691-.833 2.966-2.135 3.797C13.583 18.614 11.855 19 10 19s-3.583-.386-4.865-1.203C3.833 16.967 3 15.69 3 14c0-1.113.903-2 2.009-2M14 7a4 4 0 0 1-1.87 3.387a3 3 0 0 0-.93-.637a3 3 0 1 0-2.4 0c-.35.153-.665.37-.93.637a4 4 0 0 1-1.638-2.042A4 4 0 0 1 6 7a4 4 0 1 1 8 0"
      />
    </svg>
  );
}
export function IconLocation1({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color="currentColor"
      >
        <path d="M7 18c-1.829.412-3 1.044-3 1.754C4 20.994 7.582 22 12 22s8-1.006 8-2.246c0-.71-1.171-1.342-3-1.754m-2.5-9a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0" />
        <path d="M13.257 17.494a1.813 1.813 0 0 1-2.514 0c-3.089-2.993-7.228-6.336-5.21-11.19C6.626 3.679 9.246 2 12 2s5.375 1.68 6.467 4.304c2.016 4.847-2.113 8.207-5.21 11.19" />
      </g>
    </svg>
  );
}

export function IconPackage({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 22c-.818 0-1.6-.335-3.163-1.006C4.946 19.324 3 18.49 3 17.085V7.747M12 22c.818 0 1.6-.335 3.163-1.006C19.054 19.324 21 18.49 21 17.085V7.747M12 22v-9.83m9-4.422c0 .603-.802.984-2.405 1.747l-2.92 1.39C13.87 11.741 12.97 12.17 12 12.17m9-4.423c0-.604-.802-.985-2.405-1.748M3 7.747c0 .604.802.986 2.405 1.748l2.92 1.39c1.804.857 2.705 1.286 3.675 1.286M3 7.748c0-.604.802-.985 2.405-1.748m.927 7.311l1.994.948M12 2v2m4-1l-1.5 2M8 3l1.5 2"
        color="currentColor"
      />
    </svg>
  );
}

export function IconInstagram({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
      />
    </svg>
  );
}

export function IconOffer({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="m20.749 12l1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1 1 0 0 0-.607-.466a1 1 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a1 1 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104l1.91 1.104a1 1 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001a1.5 1.5 0 0 1 .001-3.001m.3 9.6l-1.6-1.199l6-8l1.6 1.199zm4.7.4a1.5 1.5 0 1 1 .001-3.001a1.5 1.5 0 0 1-.001 3.001"
      />
    </svg>
  );
}

export function IconStar({ fillColor }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  );
}

export function IconTooman({ fillColor, ...props }) {
  return (
    <svg className="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="31"
      viewBox="0 0 18 31"
      {...props}
    >
      <path
        d="M1.50586 16.3945C1.64648 16.3984 1.76367 16.4531 1.85742 16.5586C1.95117 16.6602 1.99609 16.7812 1.99219 16.9219C1.94531 18.1562 1.92188 19.3691 1.92188 20.5605C1.92188 21.1504 1.9375 21.623 1.96875 21.9785C2 22.334 2.0625 22.6016 2.15625 22.7812C2.25 22.957 2.39062 23.0762 2.57812 23.1387C2.76953 23.1973 3.02344 23.2266 3.33984 23.2266H3.3457C3.49023 23.2266 3.61133 23.2754 3.70898 23.373C3.80664 23.4707 3.85547 23.5918 3.85547 23.7363C3.85547 23.873 3.80664 23.9922 3.70898 24.0938C3.61133 24.1953 3.49023 24.2461 3.3457 24.2461H3.33984C2.82812 24.2461 2.41211 24.1758 2.0918 24.0352C1.77148 23.8945 1.52344 23.6758 1.34766 23.3789C1.17578 23.082 1.05664 22.7012 0.990234 22.2363C0.923828 21.7715 0.890625 21.2129 0.890625 20.5605C0.890625 19.959 0.898438 19.3516 0.914062 18.7383C0.929688 18.1211 0.949219 17.502 0.972656 16.8809C0.976562 16.7402 1.03125 16.623 1.13672 16.5293C1.24219 16.4355 1.36523 16.3906 1.50586 16.3945ZM6.67383 20.8945C6.49023 20.8945 6.33398 20.9316 6.20508 21.0059C6.08008 21.0762 5.96875 21.2051 5.87109 21.3926C5.77344 21.5762 5.66992 21.8379 5.56055 22.1777C5.48633 22.4082 5.39844 22.6445 5.29688 22.8867C5.19531 23.125 5.06445 23.3477 4.9043 23.5547C4.74414 23.7578 4.53906 23.9238 4.28906 24.0527C4.03906 24.1816 3.72656 24.2461 3.35156 24.2461C3.21484 24.2461 3.0957 24.1953 2.99414 24.0938C2.89258 23.9922 2.8418 23.873 2.8418 23.7363C2.8418 23.5918 2.89258 23.4707 2.99414 23.373C3.0957 23.2754 3.21484 23.2266 3.35156 23.2266C3.61328 23.2266 3.81445 23.1816 3.95508 23.0918C4.0957 22.998 4.20898 22.8516 4.29492 22.6523C4.38477 22.4531 4.48047 22.1914 4.58203 21.8672C4.71094 21.4492 4.86523 21.0918 5.04492 20.7949C5.22852 20.4941 5.45312 20.2637 5.71875 20.1035C5.98828 19.9434 6.31836 19.8633 6.70898 19.8633C7.09961 19.8633 7.44922 19.9785 7.75781 20.209C8.07031 20.4355 8.31641 20.7383 8.49609 21.1172C8.67578 21.4961 8.76562 21.9141 8.76562 22.3711C8.76562 22.8438 8.66602 23.2305 8.4668 23.5312C8.26758 23.832 8.01172 24.0547 7.69922 24.1992C7.38672 24.3477 7.0625 24.4219 6.72656 24.4219C6.40625 24.4219 6.08789 24.3691 5.77148 24.2637C5.45898 24.1621 5.17578 24.0117 4.92188 23.8125C4.80859 23.7266 4.74219 23.6133 4.72266 23.4727C4.70703 23.332 4.74219 23.2051 4.82812 23.0918C4.91406 22.9824 5.02734 22.918 5.16797 22.8984C5.30859 22.8789 5.43555 22.9121 5.54883 22.998C5.70508 23.1191 5.88867 23.2168 6.09961 23.291C6.31445 23.3652 6.52344 23.4023 6.72656 23.4023C7.01172 23.4023 7.25 23.3281 7.44141 23.1797C7.63672 23.0273 7.73438 22.7578 7.73438 22.3711C7.73438 22.043 7.67773 21.7695 7.56445 21.5508C7.45117 21.332 7.3125 21.168 7.14844 21.0586C6.98438 20.9492 6.82617 20.8945 6.67383 20.8945ZM11.8828 19.6406C12.2578 19.6406 12.5781 19.7402 12.8438 19.9395C13.1133 20.1348 13.3301 20.4023 13.4941 20.7422C13.6621 21.082 13.7852 21.4648 13.8633 21.8906C13.9414 22.3164 13.9805 22.7578 13.9805 23.2148C13.9805 24.3008 13.6582 25.1738 13.0137 25.834C12.373 26.498 11.5 26.9512 10.3945 27.1934C10.2578 27.2285 10.127 27.209 10.002 27.1348C9.88086 27.0645 9.80273 26.9609 9.76758 26.8242C9.73242 26.6914 9.75 26.5605 9.82031 26.4316C9.89453 26.3066 10 26.2305 10.1367 26.2031C11.1055 26.0078 11.8184 25.6602 12.2754 25.1602C12.7324 24.6641 12.9609 24.0156 12.9609 23.2148C12.9609 22.6016 12.9102 22.1094 12.8086 21.7383C12.7109 21.3633 12.582 21.0918 12.4219 20.9238C12.2617 20.7559 12.0859 20.6719 11.8945 20.6719C11.7305 20.6719 11.5742 20.7246 11.4258 20.8301C11.2773 20.9355 11.1582 21.1055 11.0684 21.3398C10.9785 21.5703 10.9336 21.873 10.9336 22.248C10.9336 22.5957 11.0059 22.8438 11.1504 22.9922C11.2285 23.0742 11.332 23.1348 11.4609 23.1738C11.5898 23.209 11.75 23.2266 11.9414 23.2266H14.6426C14.7871 23.2266 14.9082 23.2754 15.0059 23.373C15.1035 23.4707 15.1523 23.5918 15.1523 23.7363C15.1523 23.873 15.1035 23.9922 15.0059 24.0938C14.9082 24.1953 14.7871 24.2461 14.6426 24.2461H11.9414C11.6328 24.2461 11.3477 24.2109 11.0859 24.1406C10.8242 24.0703 10.5957 23.9395 10.4004 23.748C10.2129 23.5605 10.082 23.3438 10.0078 23.0977C9.9375 22.8477 9.90234 22.5879 9.90234 22.3184C9.90234 21.9863 9.94141 21.6621 10.0195 21.3457C10.1016 21.0254 10.2246 20.7383 10.3887 20.4844C10.5527 20.2266 10.7578 20.0215 11.0039 19.8691C11.2539 19.7168 11.5469 19.6406 11.8828 19.6406ZM14.3145 17.9707C14.2441 17.877 14.2188 17.7734 14.2383 17.6602C14.2578 17.543 14.3125 17.4512 14.4023 17.3848C14.6367 17.2129 14.9043 17.0762 15.2051 16.9746C15.5059 16.8691 15.832 16.8164 16.1836 16.8164C16.3945 16.8164 16.6055 16.8457 16.8164 16.9043C17.0312 16.959 17.209 17.0566 17.3496 17.1973C17.4902 17.3379 17.5508 17.5312 17.5312 17.7773C17.5312 17.9102 17.4883 18.0195 17.4023 18.1055C17.3164 18.1875 17.2148 18.2285 17.0977 18.2285C16.9961 18.2246 16.9102 18.1934 16.8398 18.1348C16.7695 18.0762 16.7285 18.0039 16.7168 17.918C16.7246 17.8203 16.6777 17.752 16.5762 17.7129C16.4785 17.6699 16.3477 17.6484 16.1836 17.6484C15.9219 17.6484 15.6836 17.6875 15.4688 17.7656C15.2539 17.8398 15.0625 17.9375 14.8945 18.0586C14.8008 18.1289 14.6973 18.1543 14.584 18.1348C14.4707 18.1113 14.3809 18.0566 14.3145 17.9707ZM16.207 19.6055C16.3438 19.5625 16.4746 19.5742 16.5996 19.6406C16.7246 19.707 16.8086 19.8086 16.8516 19.9453C16.9688 20.3125 17.0605 20.6641 17.127 21C17.1934 21.332 17.2266 21.6504 17.2266 21.9551C17.2266 22.2559 17.1875 22.5469 17.1094 22.8281C17.0352 23.1094 16.8906 23.3613 16.6758 23.584C16.4492 23.8223 16.1641 23.9922 15.8203 24.0938C15.4805 24.1953 15.0898 24.2461 14.6484 24.2461C14.5117 24.2461 14.3926 24.1953 14.291 24.0938C14.1895 23.9922 14.1387 23.873 14.1387 23.7363C14.1387 23.5918 14.1895 23.4707 14.291 23.373C14.3926 23.2754 14.5117 23.2266 14.6484 23.2266C15.0273 23.2266 15.3145 23.1914 15.5098 23.1211C15.709 23.0469 15.8516 22.9648 15.9375 22.875C16.0234 22.793 16.0879 22.6797 16.1309 22.5352C16.1738 22.3867 16.1953 22.1934 16.1953 21.9551C16.1953 21.7363 16.168 21.4824 16.1133 21.1934C16.0586 20.9043 15.9785 20.5898 15.873 20.25C15.8301 20.1133 15.8418 19.9824 15.9082 19.8574C15.9746 19.7324 16.0742 19.6484 16.207 19.6055Z"
        fill={fillColor}
      />
      <path
        d="M3.84375 10.8555C3.84375 10.707 3.90039 10.5742 4.01367 10.457C4.13086 10.3398 4.27734 10.2812 4.45312 10.2812C4.58594 10.2812 4.69531 10.3164 4.78125 10.3867C4.86719 10.457 4.93164 10.5371 4.97461 10.627C5.01758 10.7168 5.03906 10.793 5.03906 10.8555C5.03906 10.9141 5.02148 10.9941 4.98633 11.0957C4.95508 11.1973 4.89453 11.291 4.80469 11.377C4.71875 11.4629 4.5957 11.5059 4.43555 11.5059C4.2793 11.5059 4.1582 11.4648 4.07227 11.3828C3.98633 11.2969 3.92578 11.2031 3.89062 11.1016C3.85938 10.9961 3.84375 10.9141 3.84375 10.8555ZM1.99805 10.1523C2.13086 10.2031 2.22461 10.293 2.2793 10.4219C2.33789 10.5508 2.34375 10.6816 2.29688 10.8145C2.16797 11.1465 2.06836 11.5039 1.99805 11.8867C1.93164 12.2695 1.89844 12.6094 1.89844 12.9062C1.89844 13.3398 1.98047 13.7109 2.14453 14.0195C2.3125 14.3281 2.58789 14.5645 2.9707 14.7285C3.35352 14.8965 3.87305 14.9805 4.5293 14.9805C5.19336 14.9805 5.71094 14.8906 6.08203 14.7109C6.45703 14.5352 6.7207 14.2891 6.87305 13.9727C7.02539 13.6562 7.10156 13.2871 7.10156 12.8652C7.10156 12.5137 7.05469 12.1289 6.96094 11.7109C6.87109 11.2891 6.74609 10.8887 6.58594 10.5098C6.53125 10.3809 6.5293 10.25 6.58008 10.1172C6.63477 9.98438 6.72656 9.89062 6.85547 9.83594C6.98438 9.78125 7.11523 9.78125 7.24805 9.83594C7.38086 9.88672 7.47461 9.97656 7.5293 10.1055C7.7168 10.5469 7.86328 11.0078 7.96875 11.4883C8.07812 11.9648 8.13281 12.4238 8.13281 12.8652C8.13281 13.4668 8 14.0039 7.73438 14.4766C7.47266 14.9492 7.07422 15.3203 6.53906 15.5898C6.00781 15.8633 5.33789 16 4.5293 16C3.75195 16 3.08984 15.873 2.54297 15.6191C1.99609 15.3691 1.58008 15.0137 1.29492 14.5527C1.00977 14.0918 0.867188 13.543 0.867188 12.9062C0.867188 12.5352 0.90625 12.1328 0.984375 11.6992C1.06641 11.2656 1.18555 10.8496 1.3418 10.4512C1.38867 10.3184 1.47656 10.2246 1.60547 10.1699C1.73828 10.1113 1.86914 10.1055 1.99805 10.1523Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconMobile({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color={fillColor}
      >
        <path d="M5 9c0-3.3 0-4.95 1.025-5.975S8.7 2 12 2s4.95 0 5.975 1.025S19 5.7 19 9v6c0 3.3 0 4.95-1.025 5.975S15.3 22 12 22s-4.95 0-5.975-1.025S5 18.3 5 15zm6 10h2" />
        <path d="m9 2l.089.534c.193 1.157.29 1.736.686 2.088C10.19 4.989 10.776 5 12 5s1.81-.01 2.225-.378c.397-.352.493-.93.686-2.088L15 2" />
      </g>
    </svg>
  );
}

export function IconUserInfo({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.08 15.296c-1.218.738-4.412 2.243-2.466 4.126c.95.92 2.009 1.578 3.34 1.578h7.593c1.33 0 2.389-.658 3.34-1.578c1.945-1.883-1.25-3.389-2.468-4.126a9.06 9.06 0 0 0-9.338 0M13.5 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0M17 5h5m-5 3h5m-2 3h2"
        color={fillColor}
      />
    </svg>
  );
}

export function IconUserCustomer({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.578 15.482c-1.415.842-5.125 2.562-2.865 4.715C4.816 21.248 6.045 22 7.59 22h8.818c1.546 0 2.775-.752 3.878-1.803c2.26-2.153-1.45-3.873-2.865-4.715a10.66 10.66 0 0 0-10.844 0M16.5 6.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0"
        color={fillColor}
      />
    </svg>
  );
}

export function IconWalletDown({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 6.5h9.75c2.107 0 3.16 0 3.917.506a3 3 0 0 1 .827.827c.464.694.503 1.427.506 3.167M12 6.5l-.633-1.267c-.525-1.05-1.005-2.106-2.168-2.542C8.69 2.5 8.108 2.5 6.944 2.5c-1.816 0-2.724 0-3.406.38A3 3 0 0 0 2.38 4.038C2 4.72 2 5.628 2 7.444V10.5c0 4.714 0 7.071 1.464 8.535C4.822 20.394 6.944 20.493 11 20.5h1m6.5 1v-8m0 8c-.7 0-2.009-1.994-2.5-2.5m2.5 2.5c.7 0 2.009-1.994 2.5-2.5"
        color={fillColor}
      />
    </svg>
  );
}
export function IconHeart({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <path
        fill={fillColor}
        d="M7.923 10.155a10.42 10.42 0 0 1 13.806.684l2.272 2.223l2.266-2.22a10.42 10.42 0 0 1 13.809-.687c4.85 3.887 5.242 11.13.837 15.516l-16.03 15.964a1.25 1.25 0 0 1-1.764 0L7.087 25.67c-4.405-4.386-4.015-11.628.836-15.516m12.057 2.47a7.92 7.92 0 0 0-10.494-.52C5.8 15.06 5.503 20.565 8.851 23.9L24 38.986l15.148-15.087c3.348-3.334 3.05-8.839-.636-11.793a7.92 7.92 0 0 0-10.496.522l-3.141 3.077a1.25 1.25 0 0 1-1.75 0z"
      />
    </svg>
  );
}
export function IconNotFound({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1567 1024">
      <path
        d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
        fill={fillColor}
      />
    </svg>
  );
}
export function IconError({ fillColor }) {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path
        fill={fillColor}
        d="M1007.983211 512c0-273.924743-222.059492-495.984235-495.983211-495.984235S16.016789 238.075257 16.016789 512s222.059492 495.984235 495.984235 495.984235c113.738437 0 221.667565-38.428218 308.796972-107.830891 10.45205-8.325619 12.175297-23.547299 3.849678-33.998325-8.325619-10.45205-23.547299-12.175297-33.998325-3.849678-78.636988 62.638619-175.962617 97.290837-278.648324 97.290837-247.200078 0-447.595154-200.395076-447.595154-447.595154S264.799922 64.404846 512 64.404846s447.595154 200.395076 447.595154 447.595154c0 84.755336-23.572882 165.977195-67.401086 236.329497-7.065929 11.341303-3.598968 26.263154 7.742335 33.329083 11.341303 7.065929 26.263154 3.598968 33.329083-7.742335C981.841831 695.941336 1007.983211 605.866854 1007.983211 512zM524.260232 537.694195 371.999432 692.738387c-9.362228 9.534144-24.681122 9.67229-34.214243 0.310062-9.533121-9.362228-9.67229-24.681122-0.310062-34.214243l152.875806-155.669432L337.475128 347.495342c-9.362228-9.534144-9.224082-24.852014 0.310062-34.214243 9.534144-9.362228 24.852014-9.224082 34.214243 0.310062l152.260799 155.044192 152.261822-155.044192c9.362228-9.534144 24.681122-9.67229 34.214243-0.310062 9.533121 9.362228 9.67229 24.681122 0.310062 34.214243L558.170552 503.164774l152.875806 155.669432c9.362228 9.533121 9.224082 24.852014-0.310062 34.214243-9.534144 9.362228-24.852014 9.224082-34.214243-0.310062L524.260232 537.694195z"
      />
    </svg>
  );
}

export function IconSpeaker({ fillColor, ...props }) {
  return (
    <svg className="icon"
      {...props}
      viewBox="0 0 1097 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M1024 658.285714a37.632 37.632 0 0 1-6.985143-1.389714A2225.517714 2225.517714 0 0 1 950.857143 1024a1769.069714 1769.069714 0 0 0-292.571429-182.857143 1644.8 1644.8 0 0 0-329.142857-109.714286H256v219.428572a73.142857 73.142857 0 0 1-146.285714 0v-219.428572H73.142857c-40.228571 0-73.142857-98.230857-73.142857-219.428571s32.914286-219.428571 73.142857-219.428571h256a1648.237714 1648.237714 0 0 0 329.142857-109.714286 1764.022857 1764.022857 0 0 0 292.571429-182.857143 2262.601143 2262.601143 0 0 1 66.084571 367.140571A37.558857 37.558857 0 0 1 1024 365.714286c40.228571 0 73.142857 65.499429 73.142857 146.285714s-32.914286 146.285714-73.142857 146.285714zM182.857143 365.714286H109.714286v292.571428h73.142857v-292.571428z m146.285714 0H256v292.571428h73.142857v-292.571428z m585.142857-256a1622.345143 1622.345143 0 0 1-256 146.285714 1130.569143 1130.569143 0 0 1-256 73.142857v365.714286a1150.646857 1150.646857 0 0 1 256 73.142857 1595.392 1595.392 0 0 1 256 146.285714 3144.118857 3144.118857 0 0 0 36.571429-402.907428A2692.973714 2692.973714 0 0 0 914.285714 109.714286z"
      />
    </svg>
  );
}

export function IconGiftBox({ fillColor, ...props }) {
  return (
    <svg className="icon"
      {...props}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M771.52 320a403.84 403.84 0 0 0 51.456-43.136c33.408-33.408 55.744-74.496 62.912-115.712 7.872-45.184-3.68-87.136-31.616-115.104-22.304-22.304-52.512-34.08-87.36-34.08-49.632 0-101.92 23.808-143.456 65.376-66.464 66.464-105.216 158.24-126.08 223.712-15.424-65.792-46.208-154.656-106.016-214.464-32.096-32.096-73.12-48.576-111.84-48.576-31.648 0-61.792 11.008-84.256 33.472-49.984 49.984-43.232 137.792 15.072 196.096 20.8 20.8 45.088 38.048 70.72 52.416H64.032v256h64v448h768V576h64v-256h-188.48z m-97.184-191.776c27.712-27.712 62.336-44.288 92.544-44.288 10.688 0 25.696 2.24 36.448 12.992 26.016 26.016 11.424 86.304-31.264 128.992-43.936 43.936-103.072 74.176-154.432 94.048h-50.688c18.56-57.536 52.064-136.448 107.392-191.776zM233.92 160.896c-0.704-9.12-0.064-26.24 12.192-38.496 10.24-10.24 23.776-12.384 33.344-12.384 21.248 0 43.456 10.016 60.928 27.488 33.888 33.856 61.76 87.776 80.672 155.872l1.504 5.472-5.472-1.504c-68.096-18.912-122.016-46.784-155.872-80.672-15.84-15.84-25.76-36.16-27.296-55.776zM448 960H192V544h256v416z m0-448H128v-128h320v128z m384 448h-256V544h256v416z m64-448H576v-128h320v128z"
      />
    </svg>
  );
}

export function IconMedal({ fillColor, ...props }) {
  return (
    <svg className="icon"
      {...props}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M512 362.666667l90.282667 217.088 234.325333 18.773333-178.517333 152.917333 54.528 228.693334L512 857.6l-200.618667 122.538667 54.528-228.693334-178.517333-152.917333 234.325333-18.773333L512 362.666667z m0 222.165333l-31.530667 75.818667-81.749333 6.528 62.293333 53.376-19.072 79.829333L512 757.589333l70.016 42.794667-19.029333-79.786667 62.250666-53.418666-81.706666-6.528L512 584.832zM341.333333 85.333333v384H256V85.333333h85.333333z m426.666667 0v384h-85.333333V85.333333h85.333333z m-213.333333 0v213.333334h-85.333334V85.333333h85.333334z"
      />
    </svg>
  );
}
// export function Icon({ fillColor }) {
//   return (

//   )}
